import { faArrowAltCircleLeft, faCalendar, faCheckCircle, faCircle, faCircleCheck, faCircleQuestion, faClipboard, faEdit, faEye, faFile, faSquare, faSquareCheck, faStar, faTimesCircle, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faArrowCircleLeft, faArrowUpRightFromSquare, faCamera, faChartPie, faCheck, faChevronLeft, faChevronRight, faClipboardCheck, faCloudArrowUp, faInfo, faPencil, faPerson, faPersonDress, faPlus, faRefresh, faShare, faTimes, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Component, createRef } from 'react';
import { Button, Col, Container, Form, Modal, Offcanvas, Row, Spinner, ButtonGroup, Badge, Card, Tabs, Tab, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import Select from 'react-select';
import { GET, POST } from '../../api';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { ifNavAllowed, renderChildName } from '../../helpers/general_helpers';
import { t } from '../../helpers/translation_helper';
import { unsetAuthentication } from '../../redux/slices/authSlice';
import { setDefaultLanguage } from '../../redux/slices/langSlice';
import { setSelectedClass } from '../../redux/slices/selectedClassSlice';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import Subjects from '../Subjects/_Subjects';
import Timeline from './Timeline';
import { toast } from 'react-toastify';
import axios from 'axios';
import { handleFormErrors } from '../../helpers/form_helpers';
import AddEditExam from '../_common/AddEditExam/_AddEditExam';
import { Chance } from 'chance';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import Flatpickr from 'react-flatpickr';
import { sendCloudMessage } from '../../helpers/cloud_message';
import pdfAttachment from '../../assets/images/pdf.png';
import { Tooltip } from 'react-tooltip';
import { TagsInput } from 'react-tag-input-component';
import SweetAlert from 'react-bootstrap-sweetalert';
import AIGenerationButton from '../_common/AI/AIGenerationButton';
import AIGenerationModal from '../_common/AI/AIGenerationModal';
import GradeBookWidget2 from '../_partials/Widgets/GradeBookWidget2';
import Timetable2 from './Timetable2';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
const chance = new Chance();


/**
 * Dashboard Component
 */
class Dashboard extends Component {

  lessonImage = createRef();
  AddEditExam = createRef();
  ref_form_section_1_2 = createRef();
  aa_image_ref = createRef();
  refLessonKeyConcept = createRef();
  filePicker = createRef();

  /**
   * @constructor
   * @param {any} props
   */
  constructor(props) {
    super(props);

    const defaultUtTypes = [
      {
        label: "Notification",
        value: "Notification",
        picture: require('../../assets/images/user-timeline/notification.png'),
        active: true,
      },
      {
        label: "Event",
        value: "Event",
        picture: require('../../assets/images/user-timeline/event.png'),
        active: true,
      },
      {
        label: "Newsletter",
        value: "Newsletter",
        picture: require('../../assets/images/user-timeline/newsletter.png'),
        active: true,
      },
      {
        label: "Media",
        value: "Media",
        picture: require('../../assets/images/user-timeline/photos.png'),
        active: true,
      },
      {
        label: "Video",
        value: "Video",
        picture: require('../../assets/images/user-timeline/videos.png'),
        active: true,
      },
      {
        label: "Note",
        value: "Note",
        picture: require('../../assets/images/user-timeline/attachment-pink.png'),
        active: true,
      },
      {
        label: "Online Class",
        value: "Online Class",
        picture: require('../../assets/images/user-timeline/online-class.png'),
        active: true,
      },
      {
        label: "Resources",
        value: "Resources",
        picture: require('../../assets/images/user-timeline/download.png'),
        active: true,
      },
      {
        label: "Policy",
        value: "Policy",
        picture: require('../../assets/images/user-timeline/policy.png'),
        active: true,
      },
      {
        label: "Incident Report",
        value: "Incident Report",
        picture: require('../../assets/images/user-timeline/nurse-2.png'),
        active: true,
      },
      {
        label: "Poll",
        value: "Poll",
        picture: require('../../assets/images/user-timeline/poll.png'),
        active: true,
      },
      {
        label: "Survey",
        value: "Survey",
        picture: require('../../assets/images/user-timeline/survey.png'),
        active: true,
      },
      {
        label: "Observation",
        value: "Observation",
        picture: require('../../assets/images/user-timeline/grade.png'),
        active: true,
      },
      {
        label: "Agenda",
        value: "Agenda",
        picture: require('../../assets/images/user-timeline/agenda.png'),
        active: true,
      },
      {
        label: "Assignment",
        value: "Assignment",
        picture: require('../../assets/images/user-timeline/assignment.png'),
        active: true,
      },
      {
        label: "Daily Report",
        value: "Daily Report",
        picture: require('../../assets/images/user-timeline/daily-report.png'),
        active: true,
      },
      {
        label: "Exam",
        value: "Exam",
        picture: require('../../assets/images/user-timeline/exam.png'),
        active: true,
      },
      {
        label: "Homework",
        value: "Online Homework",
        picture: require('../../assets/images/user-timeline/exam.png'),
        active: true,
      },
      {
        label: "Activity",
        value: "Activity",
        picture: require('../../assets/images/user-timeline/activity.png'),
        active: true,
      },
      {
        label: "BMI",
        value: "BMI",
        picture: require('../../assets/images/user-timeline/profile.png'),
        active: true,
      },
      {
        label: "Medication Consent",
        value: "Medication Consent",
        picture: require('../../assets/images/user-timeline/nurse-2.png'),
        active: true,
      },
      {
        label: "Medicine Dose",
        value: "Medicine Dose",
        picture: require('../../assets/images/user-timeline/nurse-2.png'),
        active: true,
      },
      {
        label: "Upload",
        value: "Upload",
        picture: require('../../assets/images/user-timeline/mydocument.png'),
        active: true,
      },
      {
        label: "Exam Retake",
        value: "Exam Retake",
        picture: require('../../assets/images/user-timeline/mydocument.png'),
        active: true,
      },
      {
        label: "Academic Lesson",
        value: "Academic Lesson",
        picture: require('../../assets/images/user-timeline/journal.png'),
        active: true,
      },
      {
        label: "Pastoral Care",
        value: "Pastoral Care",
        picture: require('../../assets/images/user-timeline/nurse-2.png'),
        active: true,
      },
      {
        label: "Result",
        value: "Result",
        picture: require('../../assets/images/user-timeline/grade.png'),
        active: true,
      },
    ];

    this.formSections_AcademicActivity = [
      {
        uid: '1',
        active: true,
        completed: false,
        name: 'Tag Student',
        desc: null,
        include_ut_type: ['Academic Activity'],
        data: [
          {
            uid: '1.1',
            active: false,
            completed: false,
            name: 'Class',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
          {
            uid: '1.2',
            active: false,
            completed: false,
            name: 'Students',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
        ]
      },
      {
        uid: '2',
        active: true,
        completed: false,
        name: 'Basic',
        desc: null,
        include_ut_type: ['Academic Activity'],
        data: [

          {
            uid: '2.1',
            active: false,
            completed: false,
            name: 'Title',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
          {
            uid: '2.2',
            active: false,
            completed: false,
            name: 'Description',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
        ],
      },
      {
        uid: '12',
        active: false,
        completed: false,
        name: 'Activity',
        desc: null,
        include_ut_type: ['Academic Activity'],
        data: [
          {
            uid: '12.1',
            active: false,
            completed: false,
            name: 'Activity',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
          {
            uid: '12.2',
            active: false,
            completed: false,
            name: 'Start DateTime',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
          {
            uid: '12.3',
            active: false,
            completed: false,
            name: 'End DateTime',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
          {
            uid: '12.4',
            active: false,
            completed: false,
            name: 'Subjects',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
            include_ut_type: ['Academic Activity'],
          },
        ]
      },
    ]

    this.formSectionsActivity = [
      {
        uid: '1',
        active: true,
        completed: false,
        name: 'Activity',
        image: require('../../assets/images/formSection.png'),
        desc: t('Detail of the Activity'),
        data: [
          {
            uid: '1.1',
            active: false,
            completed: false,
            name: 'Name',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.2',
            active: false,
            completed: false,
            name: 'Central Idea',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.3',
            active: false,
            completed: false,
            name: 'Activity Design',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.4',
            active: false,
            completed: false,
            name: 'General Description',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.5',
            active: false,
            completed: false,
            name: 'Unit',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.6',
            active: false,
            completed: false,
            name: 'Image',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.7',
            active: false,
            completed: false,
            name: 'Objectives',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.8',
            active: false,
            completed: false,
            name: 'Skills',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.9',
            active: false,
            completed: false,
            name: 'Default Terms',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '1.10',
            active: false,
            completed: false,
            name: 'Grade',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          }
        ],
      },
      {
        uid: '2',
        active: true,
        completed: false,
        name: 'Attachments',
        image: require('../../assets/images/formSection.png'),
        desc: t('Resources for the activity'),
        data: [
          {
            uid: '2.1',
            active: false,
            completed: false,
            name: 'Attachments',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
          {
            uid: '2.2',
            active: false,
            completed: false,
            name: 'External Resources',
            enum: 'external_resource',
            desc: '',
            image: require('../../assets/images/lesson/hyperlink.png'),
            saveAction: () => { this.insertLessonResource(this.state.academicSubjectLessonResources.findIndex((v, i) => v.aslr_type == 'external_resource' && v.editing)) }
          },
        ]
      },
      {
        uid: '3',
        active: false,
        completed: false,
        name: 'IB',
        image: require('../../assets/images/formSection.png'),
        desc: t('Detail of the Activity'),
        data: [
          {
            uid: '3.1',
            active: false,
            completed: false,
            name: 'Transdisciplinary Theme',
            desc: null,
            image: require('../../assets/images/lesson/line-chart.png'),
          },
          {
            uid: '3.2',
            sectionGroup: ['All'],
            active: false,
            completed: false,
            name: 'Approaches to learning',
            enum: 'approaches_to_learning',
            image: require('../../assets/images/lesson/learning-approaches.png'),
            desc: ['The Approaches to Learning in PYP include transdisciplinary themes that are important for students learning both inside and outside the classroom. These are the tools that students use across all subject areas to develop into successful students. Students get the opportunity to practice these skills and reflect on how they apply these skills to their everyday learning.'],
          },
          {
            uid: '3.3',
            active: false,
            completed: false,
            name: 'Learner Profile',
            enum: 'learner_profile',
            image: require('../../assets/images/lesson/learner-profile.png'),
            desc: ['The aim of all IB programmes is to develop internationally minded people who, recognizing their common humanity and shared guardianship of the planet, help to create a better and more peaceful world. The IB learner profile represents 10 attributes valued by IB World Schools. We believe these attributes, and others like them, can help individuals and groups become responsible members of local, national and global communities.'],
          },
          {
            uid: '3.4',
            active: false,
            completed: false,
            name: 'Key Concepts',
            desc: ['It help students to engage in abstract thinking and conceptual thinking to cope-with tricky ideas. Key Concepts can help learners to deal with knowledge in transdisciplinary themes, which the IB intends to encourage. This kind of learning is not limited to factual concepts and content, helping students to engage with broader concepts that can motivate inquisitive, creative and critical thinking.'],
            image: require('../../assets/images/lesson/key-concepts.png'),
          },
          {
            uid: '3.5',
            active: false,
            completed: false,
            name: 'Goals & Success Criteria',
            desc: ['What is it we want students to know, understand and be able to do?', 'How are learning goals and success criteria co-constructed between teachers and students?'],
            image: require('../../assets/images/lesson/goal.png'),
          },
          {
            uid: '3.6',
            active: false,
            completed: false,
            name: 'Lines of Enquiry',
            desc: ['What lines of inquiry will define the scope of inquiry into the central idea?'],
            image: require('../../assets/images/lesson/inquiry.png'),
          },
        ],
      },
      {
        uid: '4',
        active: false,
        completed: false,
        name: 'Assessment',
        image: require('../../assets/images/formSection.png'),
        desc: t('Detail of the Activity'),
        data: [
          {
            uid: '4.1',
            active: false,
            completed: false,
            name: 'Questions',
            desc: null,
            image: require('../../assets/images/lesson/lesson-focus.png'),
          },
        ],
      },
    ]

    this.AcademicActivityTimelineType = {
      uid: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
      name: "Activity",
      ut_type: "Academic Activity",
      picture: require('../../assets/images/user-timeline/activity.png'),
      active: true,
      show: true,
      classmain_types: [0, 1, 2, 3, 4],
    }

    this.state = {
      utWorking: false,
      startDate: '',
      endDate: '',
      utTypes: defaultUtTypes,
      selectedUtTypes: defaultUtTypes,
      userTimelineData: [],
      offset: 0,
      finishedData: false,
      loadMore: false,
      firstLoad: true,
      calendarList: null,
      todayAtt: null,
      showDetailAttModal: false,
      showUT: false,
      termsDefault: [],
      lessonFolders: [],
      lessonModal: {
        show: false,
        close: () => {
          this.setState({
            lessonModal: {
              ...this.state.lessonModal,
              show: false,
              data: {
                name: '',
                code: '',
                url: '',
                period: 0,
                theme: '',
                aslf_id: '',
                term_d_id: '',
                image: '',
                image_prev: '',
                chatBlog: 0,
                type1: { value: 'Interdisciplinary', label: 'Interdisciplinary' },
                type2: { value: 'Standalone', label: 'Standalone' },
              }
            }
          });
        },
        data: {
          name: '',
          code: '',
          url: '',
          period: 0,
          theme: '',
          aslf_id: '',
          term_d_id: '',
          image: '',
          image_prev: '',
          chatBlog: 0,
          type1: { value: 'Interdisciplinary', label: 'Interdisciplinary' },
          type2: { value: 'Standalone', label: 'Standalone' },
        }
      },
      examstypegrp_type: '',
      formSections: [
        {
          uid: '1',
          active: true,
          completed: true,
          name: 'Activity Details',
          desc: null,
          data: [
            {
              uid: '1.1',
              active: false,
              completed: true,
              name: 'Details',
              desc: null,
              image: require('../../assets/images/lesson/lesson-focus.png'),
            },
          ]
        },
        {
          uid: '2',
          active: true,
          completed: false,
          name: 'Tagged',
          desc: null,
          data: []
        }
      ],
      refLessonKeyConcept: {
        width: 0,
        active: 0,
      },
      activityData: null,
      activityModal: {
        show: false,
        modalTitle: 'New Activity',
        closeModal: () => this.setState({ activityModal: { ...this.state.activityModal, show: false } }),
        toggleModal: () => this.setState({ activityModal: { ...this.state.activityModal, show: !this.state.activityModal.show } }),
        showModal: () => this.setState({ activityModal: { ...this.state.activityModal, show: true } }),
      },
      userTimelineModal: {
        show: false,
        toggleModal: (user_timeline = {}) => this.setState({
          userTimelineModal: { ...this.state.userTimelineModal, show: (user_timeline.name) ? true : false, user_timeline },
        }, () => {
          if (user_timeline.name) {
            this.resetUserTimelineForm()
          }
        }),
        user_timeline: {},
        saving: false
      },
      user_timeline: {
        ut_id: null,
        ut_title: '',
        ut_description: '',
        ut_url: '',
        ut_pintotop: 0,
        ut_publish_on: null,
        ut_publish_status: 1,
        ut_type: 'Assessment',
        utc_type: 'Teacher Parent',
        class_ids: {},
        ut_type_table_id: null,
        ut_type_table: null,
      },
      formSections_AcademicActivity: [],
      allTerms: [],
      selectedTerm: {},
      user_timeline_tagged_all: true,
      user_timeline_tagged: [],
      user_timeline_metadata: {
        academic_activity_ut_id: null,
        description2: '',
        start_datetime: '',
        end_datetime: '',
        acs_ids: [],
        term_ids: [],
        class_ids: [],
        assmt_id: null
      },
      user_timeline_media: [],
      allStudents: [],
      allAcademicActivities: [],
      formSectionsActivity: [...this.formSectionsActivity],
      aa_image: null,
      activeObsTab: 'Observation',
      academic_activity: {
        aa_id: 0,
        aa_name: '',
        aa_desc: '',
        aa_desc_cidea: '',
        aa_desc_unit: '',
        aa_desc_general: '',
        aa_public: 1,
        curriculum_ids: [],
        term_d_ids: []
      },
      academic_activity_resources: [],
      academic_activity_attachments: [],
      academic_activity_questions: [],
      academic_activity_question: {
        aa_q_id: null,
        aa_id: '',
        center_id: '',
        aa_q_desc: '',
        aa_q_order: '',
        aa_q_file: '',
        aa_q_type: '',
        curriculum_ids: [],
        aa_q_audio: '',
        academic_activity_question_options: [],
      },
      assessmentMenuData: null,
      selectedProgass: null,
      selectedAgegroup: null,
      selectedLearnarea: null,
      selectedAspect: null,
      curriculum: null,
      questionModal: {
        show: false,
        modalTitle: 'New Question',
        closeModal: () => this.setState({ questionModal: { ...this.state.questionModal, show: false } }),
        toggleModal: (academic_activity_question) => this.setState({ questionModal: { ...this.state.questionModal, show: !this.state.questionModal.show }, academic_activity_question }),
      },
      formSectionActive: {
        parent: '1',
        child: '1.1',
      },
      agegroups: [],
      deleteModal: { show: false, id: 0, action: () => { } },
      academicLessonAttributes: [],
      refApproachesToLearning: {
        show: false,
        ala_ids: [],
        toggleModal: (ala_id = null) => {
          let ala_ids = this.state.refApproachesToLearning.ala_ids
          if (ala_ids.includes(ala_id)) {
            ala_ids = ala_ids.filter((v) => v != ala_id)
          } else {
            ala_ids.push(ala_id)
          }
          this.setState({ refApproachesToLearning: { ...this.state.refApproachesToLearning, show: !this.state.refApproachesToLearning.show, ala_ids } })
        },
      },
      refKeyConcepts: {
        show: false,
        toggleModal: () => this.setState({ refKeyConcepts: { ...this.state.refKeyConcepts, show: !this.state.refKeyConcepts.show } }),
      },
      weeklyLessonPlanLink: 'weekly-lesson-plans',
      students: [],
    };
  }

  /**
   * Component Did Mount
   */
  componentDidMount() {
    // this.getTimeline();
    this.calendarList();
    this.getTodayAtt();
    this.getTermsDefault();
    this.getLessonFolders();
    this.getTerms();
    this.getAcademicActivities();
    this.getAssessmentMenu();
    this.getActiveProgassAgegroups();
    this.getCurriculum();
    this.getLessonAttributes();
    this.getStudents();
    this.getClassmainSubjectTimetable();
  }

  componentDidUpdate(prevProps, prevState) {

    if (
      this.props.selectedClass &&
      (!prevProps.selectedClass || this.props.selectedClass.class.class_id !== prevProps.selectedClass.class.class_id)
    ) {
      this.getStudents();
      this.getClassmainSubjectTimetable();
    }

    if (
      this.props.AIContent &&
      (
        !prevProps.AIContent ||
        this.props.AIContent.key !== prevProps.AIContent.key ||
        this.props.AIContent.value !== prevProps.AIContent.value
      )
    ) {
      this.setStateAcademicActivity(this.props.AIContent.key, this.props.AIContent.value);
    }

  }

  getTermsDefault = async () => {
    if (this.getTermsDefaultReq) {
      this.getTermsDefaultReq.abort();
    }
    this.getTermsDefaultReq = new AbortController();

    try {
      const res = await GET('academic-subject-lessons/get-terms-default',
        {
          signal: this.getTermsDefaultReq.signal,
        }
      );
      this.setState({
        termsDefault: res.data.map((v, i) => { return { ...v, label: v.term_d_name, value: v.term_d_id } })
      });
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching data!'));
    }
  };

  getLessonFolders = async () => {
    if (!this.props.selectedSubject || !this.props.selectedSubject.acs_id) {
      return;
    }

    if (this.getLessonFoldersReq) {
      this.getLessonFoldersReq.abort();
    }
    this.getLessonFoldersReq = new AbortController();

    try {
      const res = await GET('academic-subject-lesson-folders/get',
        {
          signal: this.getLessonFoldersReq.signal,
          params: {
            agegroup_id: this.props.selectedClass.class.agegroup_id,
            acs_id: this.props.selectedSubject.acs_id,
            limit: -1,
            offset: 0,
            order: 'academic_subject_lesson_folders.aslf_id'
          }
        }
      );
      this.setState({
        lessonFolders: res.data.data.map((v, i) => { return { ...v, label: v.aslf_name, value: v.aslf_id } })
      });
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching data!'));
    }
  };

  getTerms = () => {
    if (this.getTermsRequest) {
      this.getTermsRequest.abort();
    }
    this.getTermsRequest = new AbortController();
    GET('user-timeline/get-terms', {
      signal: this.getTermsRequest.signal,
    })
      .then((res) => {
        let selectedTerm = null
        res.data.find((v) => { if (v.term_active == 1) { selectedTerm = v } })
        this.setState({ allTerms: res.data, selectedTerm: (selectedTerm) ? { label: selectedTerm.term_name, value: selectedTerm.term_id, active: (selectedTerm.term_active == 1) ? true : false } : null })
      })
      .catch((err) => {
        if (axios.isCancel(err)) {

        } else {
          toast.error(
            'Something went wrong while fetching chats and contacts6!'
          );

        }
      });
  }

  getAcademicActivities = () => {
    if (this.getAcademicActivitiesReq) {
      this.getAcademicActivitiesReq.abort();
    }
    this.getAcademicActivitiesReq = new AbortController();
    GET('academic-activities/get-academic-activities', {
      signal: this.getAcademicActivitiesReq.signal
    })
      .then((res) => {
        this.setState({ allAcademicActivities: res.data })
      })
      .catch((err) => {
        if (axios.isCancel(err)) {

        } else {
          toast.error(
            'Something went wrong while fetching chats and contacts3!'
          );
        }
      });
  }

  extractClassSubjects = () => {
    let class_ids = this.state.user_timeline.class_ids

    if (class_ids.length == 1) {
      let classData = this.props.authData.classes.find((v, i) => v.class.class_id == class_ids[0].class_id)
      if (classData != undefined) {
        return classData.academic_classmain_subject.map((v) => {
          return { value: v.acs_id, label: v.acs_name, picture: v.acs_image, center_id: v.center_id, as_color: v.as_color, as_name: v.as_name }
        })
      }
      return []
    }
    return []
  }

  getActiveProgassAgegroups = async () => {
    if (this.getActiveProgassAgegroupsReq) {
      this.getActiveProgassAgegroupsReq.abort()
    }
    this.getActiveProgassAgegroupsReq = new AbortController()
    const res = await GET('academic-activities/get-active-progass-age-groups', {
      signal: this.getActiveProgassAgegroupsReq.signal,
    });
    if (res) {
      this.setState({
        agegroups: res.data.map((v) => {
          return {
            ...v,
            label: v.agegroup_code,
            value: v.agegroup_id,
          }
        })
      })
    }
  }

  getCurriculum = async () => {
    try {
      const res = await GET('academic-activities/get-curriculum');
      if (res) {
        let curriculum_options_grouped = [];
        let curriculum_options = [];
        res.data.map((v, i) => {
          let thisOptions = [];
          v.curriculum.map((vv) => {
            thisOptions.push({ label: vv.curriculum_code, value: vv.curriculum_id, learnarea_index: i });
            curriculum_options.push({ label: vv.curriculum_code, value: vv.curriculum_id, learnarea_index: i });
          });
          curriculum_options_grouped.push({
            label: v.learnarea_desc,
            options: thisOptions,
            learnarea_index: i,
            learnarea_code: v.learnarea_code
          });
        });
        this.setState({
          curriculums: { ...this.state.curriculums, learnarea: res.data, curriculum_options_grouped: curriculum_options_grouped, curriculum_options: curriculum_options },
        });
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching curriculum!'));

    }
  };

  getLessonAttributes = async () => {
    const { authData } = this.props;
    const { center_id } = authData.centerData;
    const { auth_key } = authData.loginData;

    try {
      const res = await GET('academic-subject-lessons/get-lesson-attributes');

      if (res.status == 200) {
        this.setState({ academicLessonAttributes: res.data });
      }
    } catch (err) {
      console.log('err', err)
      toast.error(
        t('Something went wrong while fetching Lesson Attributes!')
      );

    }
  };

  getStudents = async () => {
    this.setState({
      students: [],
    });
    try {
      const res = await GET('dashboard/children-list-elective-subject', {
        params: {
          order: 'children.child_name',
          limit: -1,
          offset: 0,
          dir: 'ASC',
          child_status: true,
          class_id: this.props.selectedClass.class.class_id,
          acs_id: this.props.selectedSubject?.acs_id,
        }
      });

      this.setState({
        students: res.data.data.map(v => {
          return {
            ...v,
            showMoreInfo: false
          }
        })
      });
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching students!'));
    }
  }

  getClassmainSubjectTimetable = async () => {


    if (this.props.selectedSubject) {

      const { employee_id } = this.props.authData.userData;
      const { acs_id, acs_name } = this.props.selectedSubject;
      const { class_id } = this.props.selectedClass.class;

      try {
        const res = await GET('timetable/get-classmain-subject-timetable', {
          params: {
            class_id,
            employee_id,
            acs_id,
            acs_name
          }
        });

        this.setState({
          weeklyLessonPlanLink: `/weekly-lesson-plans/${acs_id}/${res.data.tp_id}/${res.data.tt_id}/${acs_name}`,
        });


      } catch (err) {
        console.log(err);
        this.setState({
          fetching: false
        });
      }

    } else {
      this.setState({
        fetching: false
      });
    }

  }

  /**
   * Handle Selected User Timeline Types
   * @param {array} types Array of user timeline types.
   */
  handleSelectUtTypes = (types) => {
    this.setState({
      selectedUtTypes: types,
    });
  };

  /**
   * Handle Date Range
   * @param {string} dateType Name of the date field in state
   * @param {any} date Date
   */
  handleUtDateRange = (dateType, date) => {
    this.setState({
      [dateType]: date,
    });
  };

  handleOpenUT = () => {
    this.setState({
      showUT: true,
      startDate: '',
      endDate: '',
      offset: 0,
      finishedData: false,
      selectedUtTypes: this.state.utTypes,
    }, () => this.getTimeline(true));

  }

  handleCloseUT = () => {
    this.setState({
      showUT: false,
      userTimelineData: [],
    });
  }

  /**
   * Get Timeline
   * @param {boolean} reset Reset the filter
   */
  getTimeline = async (reset = false) => {
    if (this.state.finishedData || this.state.loadMore) {
      return false
    }
    this.setState({
      loadMore: true,
    }, async () => {
      if (this.state.offset === 0) {
        this.setState({ utWorking: true });
      }

      if (this.getTimelineReq) { this.getTimelineReq.abort(); }
      this.getTimelineReq = new AbortController();

      const { selectedUtTypes, startDate, endDate, userTimelineData } =
        this.state;
      const { authData, selectedClass } = this.props;
      const { class_id } = selectedClass.class;
      const { center_id, center_timezone } = authData.centerData;
      const { user_id, auth_key } = authData.loginData;

      const fData = new FormData();
      fData.append('user_id', user_id);
      fData.append('center_id', center_id);
      fData.append('center_timezone', center_timezone);
      fData.append('class_id', class_id);
      // fData.append('child_id', child_id);
      fData.append(
        'activeFilterDateFrom',
        startDate ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00' : 'null'
      );
      fData.append(
        'activeFilterDateTo',
        endDate ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : 'null'
      );
      fData.append(
        'selectedTimelineTypes',
        JSON.stringify(
          selectedUtTypes.map((item) => {
            return { ut_type: item.value, active: true };
          })
        )
      );
      fData.append('offset', this.state.offset);


      const req = await POST('user-timeline', fData, {
        signal: this.getTimelineReq.signal,
      });
      if (req) {
        if (req.status === 200) {
          let data = [];
          if (reset) {
            data = req.data.data;
          } else {
            data = [...userTimelineData, ...req.data.data];
          }

          this.setState({
            utWorking: false,
            userTimelineData: data,
            offset: this.state.offset + 10,
            loadMore: false,
            finishedData: (req.data.length <= 0) ? true : false,
            firstLoad: false
          });
          // setTimeout(() => {
          //     if (document.querySelector('.timeline-reel')) {
          //         document
          //             .querySelector('.timeline-reel')
          //             .setAttribute('style', 'height:' + (document.querySelector('.page-content-inner').offsetHeight - 60) + 'px');
          //     }
          // }, 1000);
        }
      }
    });
  };

  /**
   * Reset Filter
   */
  resetFilter = () => {
    this.setState(
      {
        startDate: '',
        endDate: '',
        offset: 0,
        finishedData: false,
        selectedUtTypes: this.state.utTypes,
      },
      () => this.getTimeline(true)
    );
  };

  applyFilter = () => {
    this.setState(
      {
        offset: 0,
        finishedData: false
      },
      () => this.getTimeline(true)
    );
  };

  calendarList = async () => {
    this.setState({
      calendarList: null
    });
    const { selectedClass } = this.props;
    const date = moment().format('YYYY-MM-DD');
    try {
      const res = await GET('center-calendar/get-center-calendar-day', {
        params: {
          date,
          class_id: selectedClass.class.class_id
        }
      });

      this.setState({
        calendarList: res.data
      });
    } catch (err) {
      console.log('err', err)
    }
  }

  getTodayAtt = async () => {

    this.setState({ todayAtt: null });

    const { class_id } = this.props.selectedClass.class;

    try {
      const res = await GET('admin/report-class-attendance', {
        params: {
          class_id
        }
      });

      this.setState({
        todayAtt: res.data
      });

    } catch (err) {
      console.log('err', err)

    }

  }

  setLessonImage = (e) => {
    const reader = new FileReader()

    const selectedFile = e.target.files[0]

    if (selectedFile) {
      reader.readAsDataURL(selectedFile)
    }

    if (!selectedFile.type.includes('image')) {
      toast.error(t('Only image file is allowed!'))
      return
    }

    reader.onload = (readerEvent) => {
      this.setState({
        lessonModal: {
          ...this.state.lessonModal,
          data: {
            ...this.state.lessonModal.data,
            image: e.target.files[0],
            image_prev: readerEvent.target.result,
          }
        }
      });
    }
  }

  insertLesson = async () => {

    // return
    this.setState({ working: true })

    const { name, code, theme, url, type1, type2, period, aslf_id, chatBlog, image, note1, term_d_id, asl_id_copy } = this.state.lessonModal.data
    const { authData } = this.props
    const { auth_key, user_id } = authData.loginData
    const { center_id, center_timezone } = authData.centerData
    let as_id, acs_id, ab_id = null
    if (this.props.selectedSubject) {
      as_id = this.props.selectedSubject.as_id
      acs_id = this.props.selectedSubject.acs_id
      ab_id = this.props.selectedSubject.ab_id
    }

    if (!term_d_id) {
      toast.warning(t('Please select Term!'))
      this.setState({
        lessonModal: {
          ...this.state.lessonModal,
          working: false,
        }
      })
      return
    }

    const fData = new FormData()
    if (asl_id_copy) {
      fData.append('asl_id_copy', asl_id_copy.asl_id)
    }
    fData.append('center_id', center_id)
    fData.append('center_timezone', center_timezone)
    fData.append('user_id', user_id)
    fData.append('AcademicSubjectLessons[as_id]', as_id)
    fData.append('AcademicSubjectLessons[aslf_id]', (aslf_id) ? aslf_id.value : null)
    fData.append('AcademicSubjectLessons[acs_id]', acs_id)
    fData.append('AcademicSubjectLessons[ab_id]', ab_id)
    fData.append('AcademicSubjectLessons[asl_name]', name)
    fData.append('AcademicSubjectLessons[asl_code]', code)
    fData.append('AcademicSubjectLessons[asl_theme]', theme)
    fData.append('AcademicSubjectLessons[asl_link]', url)
    fData.append('AcademicSubjectLessons[asl_notes1]', note1)
    fData.append('AcademicSubjectLessons[asl_period]', period)
    fData.append('AcademicSubjectLessons[asl_chat_blog]', chatBlog)
    if (term_d_id) {
      fData.append('AcademicSubjectLessons[term_d_id]', term_d_id.value)
    }
    fData.append('AcademicSubjectLessons[asl_type1]', type1.value)
    fData.append('AcademicSubjectLessons[asl_type2]', type2.value)
    fData.append('asl_attach', image)

    try {
      const res = await POST('/academic-subject-lessons/insert', fData);
      if (res) {
        if (res.data.type) {
          this.state.lessonModal.close();
          toast[res.data.messageType](t(res.data.message))
        } else {
          if (res.data.data) {
            handleFormErrors(res.data.data)
          } else {
            toast[res.data.messageType](t(res.data.message))
          }
          this.setState({ working: false })
        }
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while adding lesson!'))

      this.setState({ working: false })
    }
  }

  resetUserTimelineForm = () => {
    this.setState({
      formSectionActive: {
        parent: '1',
        child: '1.1',
      },
      user_timeline: {
        ut_id: null,
        ut_title: '',
        ut_description: '',
        ut_url: '',
        ut_pintotop: 0,
        ut_publish_on: null,
        ut_publish_status: 1,
        ut_type: 'Assessment',
        utc_type: 'Teacher Parent',
        class_ids: [],
        ut_type_table_id: null,
        ut_type_table: null,
      },
      user_timeline_metadata: {
        academic_activity_ut_id: null,
        description2: '',
        start_datetime: '',
        end_datetime: '',
        acs_ids: [],
        term_ids: [],
        class_ids: [],
      },
      user_timeline_media: [],
      user_timeline_tagged: [],
      assess_aspect: [],
      assess_curr: [],
      formSections_AcademicActivity: this.formSections_AcademicActivity
    })
  }

  renderFormAcademicActivity = () => {
    const { userTimelineModal } = this.state
    if (!userTimelineModal.show) {
      return null
    }
    const { user_timeline, user_timeline_metadata, user_timeline_media, user_timeline_tagged, ut_attachment_1, ut_attachment_2 } = this.state
    const dir = this.props.defaultLanguage.lang_orientation
    const { assessmentMenu, assessmentMenuData } = this.state
    let activeUserTimeline = userTimelineModal.user_timeline;

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    {/* NEW TIMELINE */ }
    return <Offcanvas show={userTimelineModal.show} style={{ height: '100%' }} placement='bottom' onHide={userTimelineModal.toggleModal}>
      <Offcanvas.Header id='iedu-header' style={{ marginTop: '1rem', marginRight: '1rem', marginLeft: '1rem', marginBottom: 0 }}>
        <div className='d-flex flex-row  align-items-center justify-content-center'>
          <span className='d-flex align-items-center justify-content-center btn-back-white' onClick={userTimelineModal.toggleModal}>
            <FontAwesomeIcon icon={(dir == 1) ? faAngleRight : faAngleLeft} color={brand_colors[this.props.defaultTheme.theme_id].color9} />
          </span>
          <Offcanvas.Title>
            <div className='d-flex flex-row align-items-center justify-content-center title-back-color8' >
              <div className='avatar'>
                <img src={userTimelineModal.user_timeline.picture} width="38" height="38" />
              </div>
              <span style={{ fontSize: 20, margin: '0 10px' }}>{userTimelineModal.user_timeline.name}</span>
            </div>
          </Offcanvas.Title>
        </div>
        <div className='custom-styled-form'>
          <div className='d-flex flex-row justify-content-between align-items-end'>
            {/* Publish Later */}
            <>
              <div style={{ margin: '0 20px', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, textAlign: 'center', padding: '5px 10px', borderRadius: 20 }}>
                <span style={{ fontSize: 13, color: brand_colors[this.props.defaultTheme.theme_id].color9, opacity: 0.7, fontWeight: 'bold' }}>
                  {t('Share Now')}
                </span>
                <Form.Check
                  type="switch"
                  value={1}
                  checked={(user_timeline.ut_publish_status)}
                  onChange={(event) => {
                    this.setState({ user_timeline: { ...this.state.user_timeline, ['ut_publish_on']: (event.target.checked) ? null : moment().add(1, 'days').toDate(), ut_publish_status: event.target.checked } })
                  }}
                />
              </div>
              <div style={{ margin: '0 10px' }}>
                <Form.Group>
                  <Form.Label>
                    {t('Publish Later')}
                  </Form.Label>
                  <Flatpickr
                    className='form-control'
                    data-enable-time
                    value={(user_timeline.ut_publish_on) ? moment(user_timeline.ut_publish_on).format('DD-MM-YYYY HH:mm:ss') : null}
                    onClose={([date]) => {

                      if (date) {
                        this.setState({ user_timeline: { ...this.state.user_timeline, ['ut_publish_on']: date, ut_publish_status: 0 } })
                      } else {
                        this.setState({ user_timeline: { ...this.state.user_timeline, ['ut_publish_on']: null, ut_publish_status: 1 } })
                      }
                    }}
                    options={{
                      dateFormat: 'd-m-Y H:i:S'
                    }}
                  />
                </Form.Group>
              </div>
            </>

            <Button disabled={this.state.userTimelineModal.saving} variant={user_timeline.ut_publish_status ? 'success' : 'warning'} onClick={() => setTimeout(() => {
              this.saveUserTimeline_AcademicActivityMulti()
            }, 300)}>
              {(user_timeline.ut_publish_status) ? t('Publish Now') : t('Publish Later')} {this.state.userTimelineModal.saving ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' /> : ''}
            </Button>
          </div>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div
          className={'d-flex flex-row grey-section'}
          style={{
            overflow: 'initial',
            backgroundImage: 'url(https://academic.educore.io/static/media/pegboard-bg.9b84e4936acef29bbcd9.png)',
            backgroundRepeat: 'repeat',
            backgroundPosition: '10px 12px',
            overflow: 'hidden',
          }}
        >
          <div style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, marginLeft: 10, marginRight: 10, borderRadius: '20px', width: '250px', height: '100%', top: '5px', position: 'sticky' }}>
            <div style={{ paddingRight: '1.5rem', paddingBottom: '1.5rem', paddingTop: '1rem' }}>
              {this.state.formSections_AcademicActivity.map((v, i) => {

                return (
                  <div key={i}>
                    <div className='d-flex flex-row align-items-center' style={{ cursor: 'pointer', borderRadius: '20px', paddingLeft: '5px', paddingRight: '5px', zIndex: 1, position: 'relative' }} onClick={() => this.changeToFromSection(v.uid, v.uid + '.1')}>
                      <span style={{ fontSize: 18, fontWeight: '600', color: brand_colors[this.props.defaultTheme.theme_id].color9, opacity: 0.7 }}>{v.name}</span>
                    </div>

                    <div style={{ paddingLeft: '1rem', borderLeft: 'solid 1px color18', marginLeft: '1.5rem' }}>
                      {v.data.map((vv, ii) => {
                        return (
                          <div key={ii} className='d-flex flex-row align-items-center' style={{ marginBottom: 5, marginTop: 2, cursor: 'pointer' }} onClick={() => this.changeToFromSection(v.uid, vv.uid)}>
                            <FontAwesomeIcon icon={vv.completed ? faCheckCircle : faCircle} color={vv.completed ? brand_colors[this.props.defaultTheme.theme_id].color4 : brand_colors[this.props.defaultTheme.theme_id].color18} style={{ fontSize: 12, margin: '0 5px' }} />
                            <span style={{ fontSize: 14, color: vv.completed ? brand_colors[this.props.defaultTheme.theme_id].color4 : brand_colors[this.props.defaultTheme.theme_id].color18 }}>{vv.name}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <Col className='custom-styled-form hide-scrollbar' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, marginLeft: 10, marginRight: 10, borderRadius: '20px', padding: '1rem', overflow: 'auto', height: '70vh' }}>
            {/* SECTION 1 */}
            {['Academic Activity'].includes(activeUserTimeline.ut_type) && (
              <div id='form_section_1'>
                <div className={'d-flex flex-row align-items-center justify-content-between section-heading'}>
                  <span className='heading'>{'Tag Students'}</span>
                </div>
                <Row>
                  <Col md="4">
                    {/* CLASS */}
                    <div id='form_section_1.1'>
                      <Form.Group className='mb-3'>
                        <Form.Label>{t('Class')}</Form.Label>
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          options={this.props.authData.classes.map((v, i) => { return { label: v.class.class_theme, value: v.class.class_id, ...v.class } })}
                          onChange={(event) => {
                            this.setStateUserTimeline('class_ids', event)
                          }}
                          defaultValue={user_timeline.class_ids}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          formatOptionLabel={option => (
                            <div className="d-flex flex-row">
                              {option.class_logo ? <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/classes/' + option.class_logo} style={{ width: 25, height: 25, objectFit: 'cover', marginRight: 5 }} /> : ''}
                              <div style={{ fontSize: 14 }}>
                                <div >{option.label}</div>
                                <div>
                                  <Badge bg="info">{option.agegroup_code}</Badge>
                                </div>
                              </div>
                            </div>
                          )}
                        />
                      </Form.Group>
                    </div>
                    {/* Term */}
                    <div>
                      <Form.Group className='mb-3'>
                        <Form.Label>{t('Term')}</Form.Label>
                        <Select
                          options={this.state.allTerms.map((v, i) => { return { label: v.term_name, value: v.term_id, active: (v.term_active == 1) ? true : false } })}
                          onChange={(event) =>
                            this.setState({ selectedTerm: event }, () => {
                              // this.getClassesChildren((this.state.user_timeline.class_ids.value) ? [this.state.user_timeline.class_ids] : [], 'newTimeline')
                            })
                          }
                          defaultValue={this.state.selectedTerm}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          formatOptionLabel={option => (
                            <div>
                              <span style={{ fontSize: 20 }}>
                                {option.label}
                                {option.active &&
                                  <Badge bg='success'>Active</Badge>
                                }
                              </span>
                            </div>
                          )}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                  <Col>
                    {/* STUDENTS */}
                    <div id='form_section_1.2'>
                      {!['Assessment'].includes(activeUserTimeline.ut_type) && (
                        <Form.Group >
                          <Form.Check type="switch" label={t('Select all Students in selected classes')} checked={this.state.user_timeline_tagged_all} onChange={() => {
                            if (this.setStateTimer) {
                              clearTimeout(this.setStateTimer)
                            }
                            this.setStateTimer = setTimeout(() => {
                              this.setState({ user_timeline_tagged: [], user_timeline_tagged_all: !this.state.user_timeline_tagged_all }, () => {
                                this.ref_form_section_1_2.current.setValue([])
                                this.checkCompletedFormSections()
                              })
                            }, 500);
                          }} />
                        </Form.Group>
                      )}
                      <Form.Group className='mb-3'>
                        <Form.Label>{t('Tag Students')} ( {(this.state.user_timeline_tagged_all) ? 'ALL' : user_timeline_tagged.length} )</Form.Label>
                        {/* <ButtonGroup size="sm" className='mb-1' style={{ left: 7, top: 8 }}>
                            <Button variant="primary" onClick={() => {
                              let user_timeline_tagged_new = this.state.allStudents.map((v, i) => { return { label: v.child_name, value: v.child_id, picture: v.picture, center_id: v.center_id, parent_id: v.parent_id, child_user_id: v.child_user_id, parent_user_id: v.parent_user_id, arabic_name: v.arabic_name, family_name: v.family_name, family_name_2: v.family_name_2 } })
                              this.ref_form_section_1_2.current.setValue(user_timeline_tagged_new)
                              this.setState({ user_timeline_tagged: user_timeline_tagged_new }, () => {
                                this.checkCompletedFormSections()
                              })
                            }}>{this.state.allStudentsRefreshing
                              ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' variant='primary' />
                              : 'Select All'}</Button>
                            <Button variant="warning" onClick={() => {
                              this.ref_form_section_1_2.current.setValue([])
                              this.setState({ user_timeline_tagged: [] }, () => this.checkCompletedFormSections())
                            }}>{this.state.allStudentsRefreshing
                              ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' variant='danger' />
                              : 'De-Select All'} </Button>
                          </ButtonGroup> */}
                        <Select
                          closeMenuOnSelect={false}
                          isMulti={true}
                          ref={this.ref_form_section_1_2}
                          options={this.state.allStudents.map((v, i) => { return { label: v.child_name, value: v.child_id, ...v } })}
                          onChange={(event) => {
                            if (this.setStateTimer) {
                              clearTimeout(this.setStateTimer)
                            }
                            this.setStateTimer = setTimeout(() => {
                              this.setState({ user_timeline_tagged: event }, () => {
                                this.checkCompletedFormSections()
                              })
                            }, 2000);
                          }}
                          defaultValue={user_timeline_tagged}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          formatOptionLabel={option => (
                            <div>
                              {option.picture ? <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/children/' + option.picture} style={{ width: 25, height: 25, objectFit: 'cover', marginRight: 5, borderRadius: 10 }} /> : ''}
                              <span>{option.label}</span>
                              {user_timeline.class_ids.length > 0 && <Badge bg="info" className='ms-1'>{option.class_theme}</Badge>}
                            </div>
                          )}
                          autoload={false}
                          isLoading={this.state.allStudentsRefreshing}
                          onFocus={() => this.getClassesChildren(user_timeline.class_ids, 'newTimeline')}
                        />
                        {/* <Select
                            ref={this.ref_form_section_1_2}
                            isMulti={true}
                            closeMenuOnSelect={false}
                            options={this.state.allStudents.map((v, i) => { return { label: v.child_name, value: v.child_id, picture: v.picture, center_id: v.center_id, parent_id: v.parent_id, child_user_id: v.child_user_id, parent_user_id: v.parent_user_id, arabic_name: v.arabic_name, family_name: v.family_name, family_name_2: v.family_name_2 } })}
                            onChange={(event) => {
  
                              if (this.setStateTimer) {
                                clearTimeout(this.setStateTimer)
                              }
                              this.setStateTimer = setTimeout(() => {
                                this.setState({ user_timeline_tagged: event }, () => {
                                  if (activeUserTimeline.ut_type == 'Assessment') {
                                    this.getLastOverallAssessmentAnswers()
                                    this.getLastAssessmentAnswers()
                                  }
                                  this.checkCompletedFormSections()
                                })
                              }, 2000);
                            }
                            }
                            defaultValue={user_timeline_tagged}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            formatOptionLabel={option => (
                              <div>
                                {option.picture ? <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/children/' + option.picture} style={{ width: 30, height: 30, objectFit: 'cover', marginRight: 5, borderRadius: 10 }} /> : ''}
                                <span style={{ fontSize: 16 }}>{option.label}</span>
                              </div>
                            )}
                          /> */}
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            {/* SECTION 12 */}
            {['Academic Activity'].includes(activeUserTimeline.ut_type) && (<>
              <div className={'d-flex flex-row align-items-center justify-content-between section-heading'} id='form_section_12'>
                <span className='heading'>{'Assign Activity'}</span>
                <Button variant={'primary'} size='sm' onClick={() => window.open(window.location.origin + "/activities")}>
                  <span style={{ marginRight: 10 }}><FontAwesomeIcon icon={faPlus} /></span>
                  <span>{t('New Activity')}</span>
                </Button>
              </div>
              <Row>
                {/* Activity */}
                <Col id='form_section_12.1'>
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('Activity')}
                    </Form.Label>
                    <ButtonGroup size="sm" className='mb-1' style={{ left: 7, top: 8 }}>
                      <Button variant="warning" onClick={() => this.getAcademicActivities()}>
                        <FontAwesomeIcon icon={faRefresh} />
                      </Button>
                    </ButtonGroup>
                    <Select
                      options={this.state.allAcademicActivities.map((v, i) => { return { label: v.aa_name, value: v.aa_id, center_id: v.center_id, picture: v.aa_image, aa_desc: v.aa_desc } })}
                      onChange={(event) => this.setState({ user_timeline: { ...user_timeline, ut_type_table_id: (event) ? event : null, ut_type_table: (event) ? 'academic_activities' : null, ut_title: event.label, ut_description: event.aa_desc } })}
                      value={user_timeline.ut_type_table_id}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      formatOptionLabel={option => (
                        <div>
                          {option.picture ? <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_activities/' + option.picture} style={{ width: 30, height: 30, objectFit: 'cover', marginRight: 5 }} /> : ''}
                          <span style={{ fontSize: 16 }}>{option.label}</span>
                        </div>
                      )}
                    />
                  </Form.Group>
                </Col>
                <Col id='form_section_12.2'>
                  {/* START DATETIME */}
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('Start DateTime')}
                    </Form.Label>
                    <Flatpickr
                      className='form-control'
                      data-enable-time
                      defaultValue={(user_timeline_metadata.start_datetime) ? moment(user_timeline_metadata.start_datetime).format('DD-MM-YYYY HH:mm:ss') : null}
                      // value={(user_timeline_metadata.start_datetime) ? moment(user_timeline_metadata.start_datetime).format('DD-MM-YYYY HH:mm:ss') : null}
                      onClose={([date]) => this.setStateUserTimelineMetadata('start_datetime', (date) ? date : null)}
                      options={{
                        dateFormat: 'd-m-Y H:i:S',
                        time_24hr: true
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col id='form_section_12.3'>
                  {/* END DATETIME */}
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('End DateTime')}
                    </Form.Label>
                    <Flatpickr
                      className='form-control'
                      data-enable-time
                      defaultValue={(user_timeline_metadata.end_datetime) ? moment(user_timeline_metadata.end_datetime).format('DD-MM-YYYY HH:mm:ss') : null}
                      // value={(user_timeline_metadata.end_datetime) ? moment(user_timeline_metadata.end_datetime).format('DD-MM-YYYY HH:mm:ss') : null}
                      onClose={([date]) => this.setStateUserTimelineMetadata('end_datetime', (date) ? date : null)}
                      options={{
                        dateFormat: 'd-m-Y H:i:S',
                        time_24hr: true
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col id='form_section_12.4'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Subjects')}</Form.Label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      options={this.extractClassSubjects()}
                      onChange={(event) => this.setStateUserTimelineMetadata('acs_ids', event)}
                      value={user_timeline_metadata.acs_ids}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      formatOptionLabel={option => (
                        <div>
                          {option.picture ? <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + option.picture} style={{ width: 30, height: 30, objectFit: 'cover', marginRight: 5 }} /> : ''}
                          <span style={{ fontSize: 16, color: (option.as_color) ? option.as_color : 'initial' }}>{option.label} ({option.as_name})</span>
                        </div>
                      )}
                    />
                  </Form.Group>
                </Col>
              </Row>

            </>)}
            {/* SECTION 2 */}
            {['Academic Activity'].includes(activeUserTimeline.ut_type) && (
              <div id='form_section_2'>
                <div className={'d-flex flex-row align-items-center justify-content-between section-heading'}>
                  <span className='heading'>{'Form'}</span>
                </div>
                <Row>
                  <Col>
                    {/* ut_title */}
                    {['Notification', 'Event', 'Newsletter', 'Upload', 'Media', 'Daily Report', 'Note', 'Assignment', 'Online Class', 'Assessment', 'Video', 'Exam', 'Agenda', 'Resources', 'Incident Report', 'Exam Retake', 'Poll', 'Survey', 'Online Homework', 'Academic Activity'].includes(activeUserTimeline.ut_type) && (
                      <div id='form_section_2.1'>
                        <Form.Group className='mb-3'>
                          <Form.Label>
                            {t('Title')}
                          </Form.Label>
                          <Form.Control type='text' defaultValue={user_timeline.ut_title} onBlur={(event) => this.setStateUserTimeline('ut_title', event.target.value)} />
                        </Form.Group>
                      </div>
                    )}

                    {/* ut_description */}
                    {['Notification', 'Event', 'Upload', 'Media', 'Daily Report', 'Note', 'Assignment', 'Online Class', 'Video', 'Exam', 'Agenda', 'Resources', 'Incident Report', 'Exam Retake', 'Poll', 'Survey', 'Online Homework', 'Academic Activity'].includes(activeUserTimeline.ut_type) && (
                      <div md={12} id='form_section_2.2'>
                        <Form.Group className='mb-3'>
                          <Form.Label>
                            {t('Description')}
                          </Form.Label>
                          < Form.Control as="textarea" rows={3} defaultValue={user_timeline.ut_description} onBlur={(event) => this.setStateUserTimeline('ut_description', event.target.value)} />
                        </Form.Group>
                      </div>
                    )}
                    {['Newsletter'].includes(activeUserTimeline.ut_type) && (
                      <div md={12} id='form_section_2.2'>
                        <Form.Group className='mb-3'>
                          <Form.Label>
                            {t('Description')}
                          </Form.Label>
                          <CKEditor style={{ height: 140 }} editor={Editor} data={user_timeline.ut_description} onBlur={(event, editor) => this.setStateUserTimeline('ut_description', editor.getData())} />
                        </Form.Group>
                      </div>
                    )}
                    {/* ut_url */}
                    {['Notification', 'Event', 'Note', 'Resources', 'Assignment', 'Online Class', 'Newsletter'].includes(activeUserTimeline.ut_type) &&
                      <div id='form_section_2.5'>
                        <Form.Group className='mb-3'>
                          <Form.Label>
                            {t('URL')}
                          </Form.Label>
                          <Form.Control type='text' defaultValue={user_timeline.ut_url} onBlur={(event) => this.setStateUserTimeline('ut_url', event.target.value)} />
                        </Form.Group>
                      </div>
                    }
                  </Col>
                  <Col md='4'>
                    {/* ut_attachment_1 */}
                    {['Notification', 'Event', 'Newsletter', 'Upload', 'Daily Report', 'Note', 'Assignment', 'Online Class', 'Exam', 'Resources', 'Incident Report', 'Exam Retake', 'Poll', 'Survey', 'Online Homework'].includes(activeUserTimeline.ut_type) &&
                      <div style={{ flexDirection: 'column' }} className='pic-prev d-flex justify-content-center mb-3' id='form_section_2.3'>
                        <div style={{ height: 175, padding: 10, overflow: 'hidden', borderStyle: 'dashed', borderColor: this.state.dragAreaColor.ut_attachment_1, borderWidth: 2, borderRadius: 20, position: 'relative' }} className='d-flex justify-content-center align-items-center'
                          onDragEnter={(e) => this.handleDragFileArea(e, 'ut_attachment_1')} onDragLeave={(e) => this.handleDragFileArea(e, 'ut_attachment_1')} onDragOver={(e) => this.handleDragFileArea(e, 'ut_attachment_1')} onDrop={(e) => {

                            e.preventDefault();
                            e.stopPropagation();
                            if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                              this.addAttachment({ target: { files: e.dataTransfer.files, multiple: false, name: 'ut_attachment_1' } })
                            }
                          }}>
                          {ut_attachment_1 && (!ut_attachment_1.data.type.includes('pdf')) && (
                            <img src={ut_attachment_1.url} alt={t('Preview')} style={{ height: '100%' }} />
                          )}
                          {ut_attachment_1 && (ut_attachment_1.data.type.includes('pdf')) && (
                            <img src={require('../../assets/images/pdf.png')} alt={t('PDF')} style={{ height: '100%' }} />
                          )}
                          {ut_attachment_1 == null &&
                            <button onClick={() => this.ut_attachment_1_ref.current.click()} style={{ background: 'none', border: 0, flex: 1 }}>
                              {/* <FontAwesomeIcon icon={faPlus} style={{ fontSize: 30, color: color18 }} /> */}
                              <span style={{ fontSize: 20, fontWeight: 'bold', color: brand_colors[this.props.defaultTheme.theme_id].color18 }}>{t('Custom Icon')}</span>
                            </button>
                          }

                          {ut_attachment_1 && (
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              style={{ fontSize: 14, color: brand_colors[this.props.defaultTheme.theme_id].color11, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 100, padding: 3 }}
                              onClick={() => this.deleteUserTimelineAttachment('ut_attachment_1')}
                            />
                          )}
                        </div>
                        <Form.Control className='d-none' ref={this.ut_attachment_1_ref} type='file' onChange={this.addAttachment} name='ut_attachment_1' />
                      </div>
                    }
                    {/* ut_attachment_2 */}
                    {['Notification', 'Event', 'Upload', 'Daily Report', 'Note', 'Online Class', 'Exam', 'Resources', 'Incident Report', 'Exam Retake', 'Online Homework', 'Newsletter'].includes(activeUserTimeline.ut_type) &&
                      <div style={{ flexDirection: 'column' }} className='pic-prev d-flex justify-content-center' id='form_section_2.4'>
                        <div style={{ height: 175, padding: 10, overflow: 'hidden', borderStyle: 'dashed', borderColor: this.state.dragAreaColor.ut_attachment_2, borderWidth: 2, borderRadius: 20, position: 'relative' }} className='d-flex justify-content-center align-items-center' onDragEnter={(e) => this.handleDragFileArea(e, 'ut_attachment_2')} onDragLeave={(e) => this.handleDragFileArea(e, 'ut_attachment_2')} onDragOver={(e) => this.handleDragFileArea(e, 'ut_attachment_2')} onDrop={(e) => {

                          e.preventDefault();
                          e.stopPropagation();
                          if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                            this.addAttachment({ target: { files: e.dataTransfer.files, multiple: false, name: 'ut_attachment_2' } })
                          }
                        }}>
                          {ut_attachment_2 && (!ut_attachment_2.data.type.includes('pdf')) && (
                            <img src={ut_attachment_2.url} alt={t('Preview')} style={{ height: '100%' }} />
                          )}
                          {ut_attachment_2 && (ut_attachment_2.data.type.includes('pdf')) && (
                            <img src={require('../../assets/images/pdf.png')} alt={t('PDF')} style={{ height: '100%' }} />
                          )}
                          {ut_attachment_2 == null &&
                            (
                              <button onClick={() => this.ut_attachment_2_ref.current.click()} style={{ background: 'none', border: 0, flex: 1 }}>
                                {/* <FontAwesomeIcon icon={faPlus} style={{ fontSize: 30, color: color18 }} /> */}
                                <span style={{ fontSize: 20, fontWeight: 'bold', color: brand_colors[this.props.defaultTheme.theme_id].color18 }}>{t('Attachment')}</span>
                              </button>
                            )
                          }
                          {ut_attachment_2 && (
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              style={{ fontSize: 14, color: brand_colors[this.props.defaultTheme.theme_id].color11, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 100, padding: 3 }}
                              onClick={() => this.deleteUserTimelineAttachment('ut_attachment_2')}
                            />
                          )}
                        </div>
                        <Form.Control className='d-none' ref={this.ut_attachment_2_ref} type='file' onChange={this.addAttachment} name='ut_attachment_2' />
                      </div>
                    }
                  </Col>
                </Row>
              </div>
            )}
            {/* EXTRA PADDING FROM BOTTOM */}
            <div style={{ height: 400 }}></div>
          </Col>
        </div>
      </Offcanvas.Body >
    </Offcanvas >
  }

  setStateUserTimeline = (field, value) => {
    if (this.setStateTimer) {
      clearTimeout(this.setStateTimer)
    }
    this.setStateTimer = setTimeout(() => {
      this.setState({ user_timeline: { ...this.state.user_timeline, [field]: value } }, () => {
        this.checkCompletedFormSections()
      });
    }, 100);
  };

  checkCompletedFormSections = () => {
    let { user_timeline, user_timeline_metadata, user_timeline_tagged, user_timeline_tagged_all, userTimelineModal } = this.state;
    if (!userTimelineModal.show) {
      return false
    }

    if (this.checkCompletedFormSectionsTimer) {
      clearTimeout(this.checkCompletedFormSectionsTimer)
    }
    this.checkCompletedFormSectionsTimer = setTimeout(() => {
      let formSections_AcademicActivity = this.state.formSections_AcademicActivity;
      formSections_AcademicActivity = formSections_AcademicActivity.map((v, i) => {
        let data = v.data;
        let sectionComplete = true;
        data = data.map((vv, ii) => {
          if (vv.uid == '1.1') {
            let subSectionComplete = true;
            if (user_timeline.class_ids.length > 0) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          } else if (vv.uid == '1.2') {
            let subSectionComplete = true;
            if (user_timeline_tagged.length > 0 || user_timeline_tagged_all) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          } else if (vv.uid == '2.1') {
            let subSectionComplete = true;
            if (user_timeline.ut_title) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          } else if (vv.uid == '2.2' || vv.uid == '7.1') {
            let subSectionComplete = true;
            if (user_timeline.ut_description) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          } else if (vv.uid == '5.2' || vv.uid == '9.1' || vv.uid == '8.2' || vv.uid == '12.2' || vv.uid == '10.1' || vv.uid == '11.1') {
            let subSectionComplete = true;
            if (user_timeline_metadata.start_datetime) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          } else if (vv.uid == '5.3' || vv.uid == '6.1' || vv.uid == '12.3' || vv.uid == '10.2' || vv.uid == '11.2') {
            let subSectionComplete = true;
            if (user_timeline_metadata.end_datetime) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          }
          else if (vv.uid == '8.1' || vv.uid == '6.3' || vv.uid == '12.4') {
            let subSectionComplete = true;
            if (user_timeline_metadata.acs_ids.length > 0) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          }
          else if (vv.uid == '12.1') {
            let subSectionComplete = true;
            if (user_timeline.ut_type_table_id) {
              subSectionComplete = true;
            } else {
              subSectionComplete = false;
              sectionComplete = false;
            }
            return { ...vv, completed: subSectionComplete };
          }
          else {
            sectionComplete = false;
            return { ...vv };
          }
        });
        return { ...v, data, completed: sectionComplete };
      });
      this.setState({ formSections_AcademicActivity: formSections_AcademicActivity });
    }, 1000);

  };

  getClassesChildren = (classes, actionType) => {
    if (classes.length <= 0) {
      if (this.ref_form_section_1_2.current) {
        this.ref_form_section_1_2.current.setValue([])
      }
      this.setState({ allStudents: [], allStudentsRefreshing: true })
    } else if (actionType == 'newTimeline' && this.state.selectedTerm.value == undefined) {
      if (this.ref_form_section_1_2.current) {
        this.ref_form_section_1_2.current.setValue([])
      }
      this.setState({ allStudents: [], allStudentsRefreshing: true })
    } else {
      // if (this.ref_form_section_1_2.current) {
      //   this.ref_form_section_1_2.current.setValue([])
      // }
      this.setState({ allStudents: [], allStudentsRefreshing: true })
    }


    const fData = new FormData()
    fData.append('center_id', this.props.authData.centerData.center_id)
    fData.append('class_ids', JSON.stringify(classes.map((v, i) => v.class_id)))
    if (actionType == 'newTimeline') {
      fData.append('term_id', this.state.selectedTerm.value)
    }
    if (this.getClassesChildrenRequest) {
      this.getClassesChildrenRequest.abort();
    }
    this.getClassesChildrenRequest = new AbortController();
    POST('children/get-classes-children', fData, {
      signal: this.getClassesChildrenRequest.signal,
    })
      .then((res) => {

        let resData = res.data
        if (Array.isArray(resData)) {
          this.setState({ allStudents: resData, allStudentsRefreshing: false })
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {

        } else {
          toast.error(
            'Something went wrong while fetching chats and contacts1!'
          );

        }
      });
  }

  setStateUserTimelineMetadata = (field, value) => {
    this.setState({ user_timeline_metadata: { ...this.state.user_timeline_metadata, [field]: value } }, () => {
      this.checkCompletedFormSections()
    });
  };

  saveUserTimeline_AcademicActivityMulti = () => {

    let userTimelineModal = this.state.userTimelineModal
    let { ut_attachment_1, ut_attachment_2, user_timeline_media } = this.state
    this.setState({
      userTimelineModal: {
        ...this.state.userTimelineModal,
        saving: true
      }
    })
    if (this.state.userTimelineModal.saving) {
      return
    }

    let user_timeline_metadata = JSON.parse(JSON.stringify(this.state.user_timeline_metadata))
    let user_timeline_tagged = this.state.user_timeline_tagged
    let user_timeline = JSON.parse(JSON.stringify(this.state.user_timeline))
    let class_ids = user_timeline.class_ids
    user_timeline.ut_type = userTimelineModal.user_timeline.ut_type
    user_timeline.ut_publish_status = (user_timeline.ut_publish_status) ? 1 : 0
    user_timeline.ut_publish_on = (user_timeline.ut_publish_on) ? moment(user_timeline.ut_publish_on).format('YYYY-MM-DD HH:mm:ss') : null
    user_timeline_metadata.term_ids = user_timeline_metadata.term_ids.map((v, i) => v.value)
    user_timeline_metadata.class_ids = user_timeline_metadata.class_ids.map((v, i) => parseInt(v.class_id))
    user_timeline_metadata.acs_ids = user_timeline_metadata.acs_ids.map((v, i) => parseInt(v.value))
    user_timeline_metadata.start_datetime = (user_timeline_metadata.start_datetime) ? moment(user_timeline_metadata.start_datetime).format('YYYY-MM-DD HH:mm:ss') : null
    user_timeline_metadata.end_datetime = (user_timeline_metadata.end_datetime) ? moment(user_timeline_metadata.end_datetime).format('YYYY-MM-DD HH:mm:ss') : null
    user_timeline.ut_type_table_id = (user_timeline.ut_type_table_id) ? user_timeline.ut_type_table_id.value : null

    let allRequests = []
    class_ids.map((v) => {
      user_timeline.class_ids = [v.class_id]
      allRequests.push(this.saveUserTimeline_AcademicActivity_Promise(user_timeline, user_timeline_metadata, user_timeline_tagged, userTimelineModal))
    })

    Promise.all(allRequests).then((values) => {
      let anyErrors = false

      values.map((resData) => {
        if (resData.type) {
          if (user_timeline.ut_publish_on == null) {
            let ut_type = user_timeline.ut_type
            let ut_id = user_timeline.ut_id
            // MEDIA(RESTRICTED ACCESS) & OTHER TYPES
            resData.user_timeline_tagged.map((v, i) => {
              let body = user_timeline.ut_title
              let data = { 'ut_id': resData.data.ut_id, 'actionType': 'user_timeline' }
              if (v.child_user_id) {
                let title = (ut_id) ? 'Updated: ' + ut_type : 'New: ' + ut_type
                sendCloudMessage(v.child_user_id, title, body, data)
              }
              if (v.parent_user_id) {
                let title = (ut_id) ? 'Updated: ' + ut_type + ' for ' + renderChildName(v.child_name, v.arabic_name, v.family_name, v.family_name_2) : 'New: ' + ut_type + ' for ' + renderChildName(v.child_name, v.arabic_name, v.family_name, v.family_name_2)
                sendCloudMessage(v.parent_user_id, title, body, data)
              }
            })
          }
        } else {
          anyErrors = true
          if (resData.data != null) {
            handleFormErrors(resData.data);
          } else {
            toast.error(t(resData.message));
          }
        }
      })

      if (!anyErrors) {
        // RESET FROM
        this.setState({
          userTimelineModal: {
            ...this.state.userTimelineModal,
            show: false,
            user_timeline: {},
            saving: false
          },
          formSectionActive: {
            parent: '1',
            child: '1.1',
          },
          formSections_AcademicActivity: this.formSections_AcademicActivity,
          user_timeline: {
            ut_id: null,
            ut_title: '',
            ut_description: '',
            ut_url: '',
            ut_pintotop: 0,
            ut_publish_on: null,
            ut_publish_status: 1,
            ut_type: null,
            utc_type: 'Teacher Parent',
            class_ids: [],
            ut_type_table_id: null,
            ut_type_table: null,
          },
          user_timeline_tagged: [],
          user_timeline_tagged_all: true,
          user_timeline_metadata: {
            academic_activity_ut_id: null,
            description2: '',
            start_datetime: '',
            end_datetime: '',
            acs_ids: [],
            term_ids: [],
            class_ids: [],
          },
        }, () => this.resetFilter())

        toast.success(t('Saved Successfully'));
      } else {
        toast.success(t('Something went wrong'));
      }
    }).catch(function (error) {
      console.log('error', error);
      toast.success(t('Something went wrong'));
    })
  }

  saveUserTimeline_AcademicActivity_Promise = (user_timeline, user_timeline_metadata, user_timeline_tagged, userTimelineModal) => {

    return new Promise((resolve, reject) => {

      let fData = new FormData()
      fData.append('center_id', this.props.authData.centerData.center_id)
      fData.append('class_id', 'undefined')
      fData.append('user_timeline', JSON.stringify(user_timeline))
      fData.append('user_timeline_metadata', JSON.stringify(user_timeline_metadata))
      fData.append('user_timeline_tagged_all', this.state.user_timeline_tagged_all)
      fData.append('term_id', this.state.selectedTerm.value)
      fData.append('user_timeline_tagged', JSON.stringify(user_timeline_tagged))
      fData.append('ut_id', user_timeline.ut_id)
      fData.append('ut_type', userTimelineModal.user_timeline.ut_type)
      fData.append('user_id', this.props.authData.loginData.user_id)
      fData.append('center_timezone', this.props.authData.centerData.center_timezone)
      fData.append('employee_id', this.props.authData.userData.employee_id)
      fData.append('employee_photo_approve', this.props.authData.userData.employee_photo_approve)

      // return
      // if (this.saveUserTimelineReq) {
      //   this.saveUserTimelineReq.abort();
      // }
      this.saveUserTimelineReq = new AbortController();

      let URL = 'user-timeline/save-user-timeline'
      POST(URL, fData, {
        signal: this.saveUserTimelineReq.signal,
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          }
        })
    })
  }

  saveActivity = async () => {
    this.setState({ working: true });
    let { academic_activity, aa_image, academic_activity_attachments, academic_activity_questions, academic_activity_resources } = this.state;
    academic_activity = { ...academic_activity }
    let aa_audio = await this.readAudioFileData(this.state.aa_audio);
    academic_activity.term_d_ids = academic_activity.term_d_ids.map((v) => v.value)
    academic_activity.agegroup_id = academic_activity.agegroup_id?.value

    const fData = new FormData();
    if (aa_audio) {
      fData.append('aa_audio', aa_audio);
    }
    if (aa_image) {
      fData.append('aa_image', aa_image.data);
    }
    fData.append('academic_activity', JSON.stringify(academic_activity));
    fData.append('academic_activity_questions', JSON.stringify(academic_activity_questions));
    fData.append('academic_activity_resources', JSON.stringify(academic_activity_resources));
    academic_activity_attachments
      .filter(v => v.data instanceof File)
      .map((v, i) => {
        fData.append('academic_activity_attachments[]', v.data);
        fData.append('academic_activity_attachment_captions[]', v.caption);
      });


    academic_activity_questions.map((v, i) => {
      let aa_q_id = v.aa_q_id;
      v.academic_activity_question_options.map((vv, ii) => {
        if (vv.aa_q_op_value_picture) {
          fData.append('aa_q_op_value_picture[' + ii + '][' + aa_q_id + ']', vv.aa_q_op_value_picture);
        }
        if (vv.aa_q_op_text_picture) {
          fData.append('aa_q_op_text_picture[' + ii + '][' + aa_q_id + ']', vv.aa_q_op_text_picture);
        }
      });
    });

    try {
      if (this.saveActivityReq) {
        this.saveActivityReq.abort();
      }
      this.saveActivityReq = new AbortController();

      const res = await POST('academic-activities/save-activity', fData, {
        signal: this.saveActivityReq.signal,
      });
      if (res) {
        let resData = res.data
        if (resData.type) {
          this.setState({
            working: false,
            academic_activity: {
              aa_id: 0,
              aa_name: '',
              aa_desc: '',
              aa_desc_cidea: '',
              aa_desc_unit: '',
              aa_desc_general: '',
              aa_public: 1,
              curriculum_ids: [],
              term_d_ids: [],
              agegroup_id: null,
            },
            aa_image: null,
            aa_audio: null,
            academic_activity_attachments: [],
            academic_activity_attachment_caption: '',
            academic_activity_questions: [],
            academic_activity_resources: [],
            academic_activity_question: {
              aa_q_id: null,
              aa_id: '',
              center_id: '',
              aa_q_desc: '',
              aa_q_order: '',
              aa_q_file: '',
              aa_q_type: '',
              curriculum_ids: [],
              aa_q_audio: '',
              academic_activity_question_options: [],
            },
            activityModal: { ...this.state.activityModal, show: false },
          });

        } else {
          if (resData.data != null) {
            handleFormErrors(resData.data);
          } else {
            toast.error(t(resData.message));
          }
          this.setState({
            working: false,
          });
        }
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while saving activity!'));
      this.setState({ working: false });

    }
  };

  resetFormActivity = () => {
    this.setState({
      academic_activity: {
        aa_id: 0,
        aa_name: '',
        aa_desc: '',
        aa_desc_cidea: '',
        aa_desc_unit: '',
        aa_desc_general: '',
        aa_public: 1,
        curriculum_ids: [],
        term_d_ids: []
      },
      aa_image: null,
      aa_audio: null,
      academic_activity_attachments: [],
      academic_activity_attachment_caption: '',
      academic_activity_questions: [],
      academic_activity_resources: [],
      academic_activity_question: {
        aa_q_id: null,
        aa_id: '',
        center_id: '',
        aa_q_desc: '',
        aa_q_order: '',
        aa_q_file: '',
        aa_q_type: '',
        curriculum_ids: [],
        aa_q_audio: '',
        academic_activity_question_options: [],
      },
      // academic_activity_resource: {
      //     aar_id: null,
      //     aar_type: '',
      //     aar_type_id: '',
      //     aar_title: '',
      //     aar_desc: '',
      // },
      // DDL OPTIONS
      aa_attach_type: [
        { value: 'document', label: 'Document' },
        { value: 'image', label: 'Image' },
        { value: 'audio', label: 'Audio' },
        { value: 'video', label: 'Video' },
      ],
      aa_q_type: [
        { value: 'MCQ', label: 'Multiple Choice' },
        { value: 'MRQ', label: 'Multiple Response' },
        { value: 'TF', label: 'True False' },
        { value: 'BD', label: 'Brief Description' },
        { value: 'DD', label: 'Detail Description' },
        { value: 'Match', label: 'Matching' },
        { value: 'File', label: 'FIle Upload' },
        { value: 'Blanks', label: 'Fill in the Blanks' },
        { value: 'Audio', label: 'Record Audio' },
      ],
      filterCurriculum: 'ALL', //ALL,LINKED
    });
  };

  checkCompletedFormSectionsActivity = () => {
    let formSectionsActivity = this.state.formSectionsActivity;
    formSectionsActivity = formSectionsActivity.map((v, i) => {
      let data = v.data;
      let sectionComplete = true;
      data = data.map((vv, ii) => {
        if (vv.uid == '1.1') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.aa_name) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.2') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.aa_desc_cidea) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.3') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.aa_desc) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.4') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.aa_desc_general) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.5') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.aa_desc_unit) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.6') {
          let subSectionComplete = true;
          if (this.state.aa_image) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.7') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.curriculum_ids.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.8') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'skill' && !v.editing);
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.9') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.term_d_ids.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '1.10') {
          let academic_activity = this.state.academic_activity;
          let subSectionComplete = true;
          if (academic_activity.agegroup_id) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '2.1') {
          let academic_activity_attachments = this.state.academic_activity_attachments;
          let subSectionComplete = true;
          if (academic_activity_attachments.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '2.2') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'external_resource' && !v.editing);
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '3.1') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'transdisciplinary_theme_focus');
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '3.2') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'approaches_to_learning');
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '3.3') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'learner_profile');
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '3.4') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'lesson_key_concept');
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '3.5') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'success' && !v.editing);
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '3.6') {
          let academic_activity_resources = this.state.academic_activity_resources.filter((v, i) => v.aar_type == 'lines_of_enquiry');
          let subSectionComplete = true;
          if (academic_activity_resources.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        } else if (vv.uid == '4.1') {
          let academic_activity_questions = this.state.academic_activity_questions;
          let subSectionComplete = true;
          if (academic_activity_questions.length > 0) {
            subSectionComplete = true;
          } else {
            subSectionComplete = false;
            sectionComplete = false;
          }
          return { ...vv, completed: subSectionComplete };
        }
        // else {
        //   sectionComplete = false;
        //   return { ...vv };
        // }

      });
      return { ...v, data, completed: sectionComplete };
    });
    this.setState({ formSectionsActivity: formSectionsActivity });
  };

  getAssessmentMenu = () => {
    if (typeof this.getAssessmentMenuRequest != typeof undefined) {
      this.getAssessmentMenuRequest.abort();
    }

    this.getAssessmentMenuRequest = new AbortController();

    if (typeof this.getAllCurriculumRequest != typeof undefined) {
      this.getAllCurriculumRequest.abort();
    }

    this.getAllCurriculumRequest = new AbortController();

    axios
      .all([
        GET('assesslog/get-assessment-menu', {
          signal: this.getAssessmentMenuRequest.signal,
        }),
        GET('assesslog/get-all-curriculum', {
          signal: this.getAllCurriculumRequest.signal,
        }),
      ])
      .then(
        axios.spread((assessmentMenuData, getAllCurriculumData) => {
          this.setState({
            assessmentMenuData: {
              ...assessmentMenuData.data,
              allCurriculum: getAllCurriculumData.data
            }
          });
        }))
      .catch((err) => {
        if (axios.isCancel(err)) {

        } else {
          toast.error(
            'Something went wrong!'
          );

        }
      });
  }

  setStateAcademicActivity = (field, value) => {
    this.setState({ academic_activity: { ...this.state.academic_activity, [field]: value } }
      , () => this.checkCompletedFormSectionsActivity());
  };

  changeToFromSection = (parent, child) => {
    this.setState(
      {
        formSectionActive: { parent: parent, child: child },
      },
      () => {
        setTimeout(() => {
          const element = document.getElementById('form_section_' + child);
          if (element) {
            // 👇 Will scroll smoothly to the top of the next section
            element.scrollIntoView({ behavior: 'smooth' });

            if (this.refLessonKeyConcept.current && !this.state.refLessonKeyConcept.width) {
              // console.log('this.refLessonKeyConcept', this.refLessonKeyConcept.current.clientWidth)
              this.setState({ refLessonKeyConcept: { ...this.state.refLessonKeyConcept, width: this.refLessonKeyConcept.current.clientWidth } })
            }

          }
        }, 300);
      }
    );
  };

  readFile = (selectedFile) => {
    return new Promise(function (resolve, reject) {
      let reader = new FileReader();
      const allowedFiles = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'audio/x-m4a', 'audio/mp3', 'audio/mp4'];
      const allowedFilesDisplay = ['PDF', 'Image'];
      const allowedSize = 5000000;

      if (selectedFile.size) {
        if (selectedFile.size >= allowedSize) {
          toast.error(t('Max file size allowed is ' + allowedSize / 1000000 + ' MB!'));
          resolve({ type: 'error' });
          return;
        } else if (!allowedFiles.includes(selectedFile.type)) {
          toast.error(t('Allowed file type are ' + allowedFilesDisplay.toString()));
          resolve({ type: 'error' });
          return;
        } else {
          if (selectedFile.type.includes('image')) {
            reader.readAsDataURL(selectedFile);
          } else if (selectedFile.type.includes('audio')) {
            reader.readAsArrayBuffer(selectedFile);
          } else {
            reader.readAsText(selectedFile);
          }
        }

        reader.onload = async (readerEvent) => {
          resolve({ type: 'success', data: selectedFile, url: readerEvent.target.result });
        };
        reader.onerror = (error) => {
          resolve({ type: 'error' });
        };
      } else {
        resolve({ type: 'error' });
      }
    });
  };
  addActivityAttachment = (e) => {
    const selectedFiles = e.target.files;
    let allFiles = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      allFiles.push(this.readFile(selectedFiles[i]));
    }

    Promise.all(allFiles).then((values) => {
      let caption = this.state.academic_activity_attachment_caption;
      let attachments = e.target.multiple ? this.state[e.target.name] : null;
      let selectedFiles = values;
      selectedFiles.map((v, i) => {
        if (v.data.type) {
          if (e.target.multiple) {
            attachments.push({ url: v.url, data: v.data, caption, edit: true });
          } else {
            attachments = { url: v.url, data: v.data, caption, edit: true };
          }
        }
      });
      this.setState({
        [e.target.name]: attachments,
      }, () => this.checkCompletedFormSectionsActivity());
    });
  };

  setActivityResource = (field, value, aar_type, aar_id) => {
    let academic_activity_resources = this.state.academic_activity_resources;
    let findIndex = academic_activity_resources.findIndex((v, i) => v.aar_type == aar_type && v.aar_id == aar_id);
    if (findIndex != -1) {
      academic_activity_resources[findIndex][field] = value;
    } else {
      academic_activity_resources.push({
        aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
        aar_type: aar_type,
        aar_type_id: null,
        aar_title: '',
        aar_desc: '',
        aar_url: '',
        aar_public: 1,
        [field]: value,
        editing: true,
      });
    }
    this.setState({ academic_activity_resources });
  };

  onChangeProgass = (obj) => {
    this.setState({ selectedProgass: obj });
  };
  onChangeAge = (obj) => {
    this.setState({ selectedAgegroup: obj });
  };
  onChangeLearnArea = (obj) => {
    this.setState({ selectedLearnarea: obj });
  };
  onChangeAspect = (obj) => {
    this.setState({ selectedAspect: obj });
  };

  setStateAcademicActivityQuestion = (field, value) => {
    this.setState({ academic_activity_question: { ...this.state.academic_activity_question, academic_activity_question_options: field == 'aa_q_type' && value != this.state.academic_activity_question.aa_q_type ? [] : this.state.academic_activity_question.academic_activity_question_options, [field]: value } });
  };

  addUpdateQuestion = () => {
    const { academic_activity_question } = this.state;
    const academic_activity_question_options = academic_activity_question.academic_activity_question_options;
    // Question type is required
    if (academic_activity_question.aa_q_type == '') {
      toast.error(t('Question type is required!'));
      return;
    }
    if (academic_activity_question.aa_q_desc == '') {
      toast.error(t('Question desc is required!'));
      return;
    }

    // options are less than 2
    if ((academic_activity_question.aa_q_type == 'TF' || academic_activity_question.aa_q_type == 'MCQ' || academic_activity_question.aa_q_type == 'MRQ') && academic_activity_question_options.length < 2) {
      toast.error(t('Please add two options at-least!'));
      return;
    } else if (academic_activity_question.aa_q_type == 'TF' || academic_activity_question.aa_q_type == 'MCQ' || academic_activity_question.aa_q_type == 'MRQ') {
      let findCheckedOption = academic_activity_question_options.find((v, i) => v.aa_q_op_checked);
      if (findCheckedOption == undefined) {
        toast.error(t('At-least on option should be marked as correct!'));
        return;
      }
    }

    academic_activity_question['academic_activity_question_options'] = academic_activity_question_options

    let academic_activity_questions = this.state.academic_activity_questions;
    if (academic_activity_question.aa_q_id == null) {
      academic_activity_question.aa_q_id = chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0];
      academic_activity_questions.push(academic_activity_question);
    } else {
      let findQuestion = academic_activity_questions.findIndex((v, i) => v.aa_q_id == academic_activity_question.aa_q_id);
      academic_activity_questions[findQuestion] = academic_activity_question;
    }
    this.setState(
      {
        academic_activity_questions,
        questionModal: { ...this.state.questionModal, show: false },
      },
      () => this.checkCompletedFormSections()
    );
  };

  editQuestion = (id) => {
    this.setState({ academic_activity_question: this.state.academic_activity_questions[id], questionModal: { ...this.state.questionModal, modalTitle: 'Update Question', show: true } });
  };

  addQuestionOption = () => {
    const { academic_activity_question } = this.state;

    // Don't let user add more than two options
    // if question type is true/false
    if (academic_activity_question.aa_q_type == 'TF' && academic_activity_question.academic_activity_question_options.length === 2) {
      toast.error(t('Only two options can be added for true/false Question!'));
      return;
    }

    const new_academic_activity_question_options = {
      aa_q_op_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
      aa_q_id: academic_activity_question.aa_q_id,
      aa_id: '',
      center_id: '',
      aa_q_op_text: '',
      aa_q_op_text_picture: '',
      aa_q_op_value: '',
      aa_q_op_value_picture: '',
      aa_q_op_checked: 0,
    };

    academic_activity_question.academic_activity_question_options.push(new_academic_activity_question_options);

    this.setState({ academic_activity_question });
  };

  handleOptionFileChange = (index) => (e) => {
    const { academic_activity_question_options } = this.state.academic_activity_question;
    academic_activity_question_options[index][e.target.name] = e.target.files[0];
    this.setState({ academic_activity_question: { ...this.state.academic_activity_question, academic_activity_question_options } });
  };

  handleOptionTextChange = (index) => (e) => {
    const { academic_activity_question_options } = this.state.academic_activity_question;

    academic_activity_question_options[index][e.target.name] = e.target.value;
    this.setState({ academic_activity_question: { ...this.state.academic_activity_question, academic_activity_question_options } });
  };

  deleteOption = (id) => {
    const { academic_activity_question_options } = this.state.academic_activity_question;

    academic_activity_question_options.splice(id, 1);
    this.setState({ academic_activity_question: { ...this.state.academic_activity_question, academic_activity_question_options } });
  };
  handleOptionTagsChange = (index, name) => (e) => {
    const { academic_activity_question_options } = this.state.academic_activity_question;

    academic_activity_question_options[index][name] = e;
    this.setState({ academic_activity_question: { ...this.state.academic_activity_question, academic_activity_question_options } });
  };
  handleOptionCheckChange = (index, state_name, select_single = false) => {
    const { academic_activity_question_options } = this.state.academic_activity_question;

    if (select_single) {
      for (var i = 0; i < academic_activity_question_options.length; i++) {
        academic_activity_question_options[i][state_name] = 0;
      }
    }
    academic_activity_question_options[index][state_name] = academic_activity_question_options[index][state_name] == 0 ? 1 : 0;
    this.setState({ academic_activity_question: { ...this.state.academic_activity_question, academic_activity_question_options } });
  };


  setAIResources = (resources) => {
    let academic_activity_resources = [...this.state.academic_activity_resources];
    resources.forEach(resource => {
      academic_activity_resources.push({
        aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
        aar_type: 'external_resource',
        aar_type_id: null,
        aar_title: resource.title,
        aar_desc: '',
        aar_url: resource.link,
        aar_public: 1,
        editing: false,
      });
    });
    this.setState({ academic_activity_resources });
  };

  readAudioFileData = async (mediaBlobUrl) => {
    if (!mediaBlobUrl) return null;
    const audioBlob = await fetch(mediaBlobUrl).then((r) => r.blob());
    return new File([audioBlob], `${chance.guid()}.wav`, { type: 'audio/wav' });
  };

  mailCredentials = async (studentData) => {

    const { authData } = this.props;

    const res = await GET('children/send-parent-credentials', {
      params: {
        parent_id: studentData.parent_id,
        center_email: authData.centerData.email1,
        center_name: authData.centerData.center_name,
        child_id: studentData.child_id,
      },
    });

    if (res.data.type) {
      toast.warning(t('Credentials sent successfully!'));
    } else {
      toast.error(t(res.data.message));
    }
  }

  getStudentAge = (student) => {
    let birthDate = moment(student.birth_date, "YYYY-MM-DD")
    let today = moment(new Date()),
      intervals = ['years', 'months', 'weeks', 'days'],
      out = [];
    intervals.forEach((interval) => {
      var diff = today.diff(birthDate, interval);
      birthDate.add(diff, interval);
      out.push(diff + interval.slice(0, 1));
    });
    return out.join(', ');
  }

  renderClassAtt = () => {
    const { total_present = 0, total_not_marked = 0, total_absent = 0 } = this.state.todayAtt;

    const total = total_present + total_not_marked + total_absent || 1;
    const percentPresent = (total_present / total) * 100;
    const percentNotMarked = (total_not_marked / total) * 100;
    const percentAbsent = (total_absent / total) * 100;

    return (
      <div>
        <div style={{
          display: 'flex',
          height: 7,
          width: '100%',
          borderRadius: 4,
          overflow: 'hidden',
          background: '#e9ecef',
          boxShadow: 'inset 0 1px 2px #ddd',
          marginBottom: 10
        }}>
          <div
            style={{
              width: `${percentPresent}%`,
              background: '#538DEE',
              transition: 'width 0.3s',
              height: '100%',
            }}
            title={`Present: ${total_present}`}
          />
          <div
            style={{
              width: `${percentNotMarked}%`,
              background: '#F3BF00',
              transition: 'width 0.3s',
              height: '100%',
            }}
            title={`Not Marked: ${total_not_marked}`}
          />
          <div
            style={{
              width: `${percentAbsent}%`,
              background: '#A80000',
              transition: 'width 0.3s',
              height: '100%',
            }}
            title={`Absent: ${total_absent}`}
          />
        </div>
        {/* <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginTop: 4 }}>
                              <span style={{ color: '#538DEE' }}>Present: {total_present} ({percentPresent.toFixed(1)}%)</span>
                              <span style={{ color: '#F3BF00' }}>Not Marked: {total_not_marked} ({percentNotMarked.toFixed(1)}%)</span>
                              <span style={{ color: '#A80000' }}>Absent: {total_absent} ({percentAbsent.toFixed(1)}%)</span>
                            </div> */}
        <Row style={{ fontSize: 13 }}>
          <Col>
            <Row>
              <Col>
                <span style={{
                  width: 15, height: 10, backgroundColor: '#538DEE', display: 'inline-block', marginRight: 5
                }}></span>
                {t('Present')}
              </Col>
              <Col md='auto'><strong>{total_present}</strong></Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col className='pe-0'>
                <span style={{
                  width: 15, height: 10, backgroundColor: '#F3BF00', display: 'inline-block', marginRight: 5
                }}></span>
                {t('Not Marked')}
              </Col>
              <Col className='ps-0' md='auto'><strong>{total_not_marked}</strong></Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col>
                <span style={{
                  width: 15, height: 10, backgroundColor: '#A80000', display: 'inline-block', marginRight: 5
                }}></span>
                {t('Absent')}
              </Col>
              <Col md='auto'><strong>{total_absent}</strong></Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }

  renderDailyTask = (item, index) => {
    const typeMap = {
      exams: { color: '#538DEE', label: 'EXAMS' },
      stdassign: { color: '#F3BF00', label: 'ASSIGNMENT' },
      events: { color: '#00B894', label: 'EVENT' },
      calendar: { color: '#6C63FF', label: 'CALENDER' },
      agenda: { color: '#FF7675', label: 'AGENDA' },
      classwork: { color: '#00B8D9', label: 'CLASS WORK' },
      academic_activities: { color: '#A29BFE', label: 'ACTIVITY' },
      homework: { color: '#E17055', label: 'HOMEWORK' },
    };

    const typeInfo = typeMap[item.add_type] || { color: '#000', label: item.add_type?.toUpperCase() || '' };
    const body = item.body ? item.body.replace(/(<([^>]+)>)/gi, "") : "";

    return (
      <div
        key={index}
        style={{
          background: '#fff',
          borderRadius: 5,
          borderLeft: `3px solid ${typeInfo.color}`,
          padding: '7px 10px',
          marginBottom: 5,
        }}
      >
        <Row>
          <Col className='d-flex align-items-center' style={{ fontSize: 14 }}>
            {item.title} - {body.length > 50 ? body.substring(0, 50) + '...' : body}
          </Col>
          <Col className='pe-2 d-flex align-items-center' md='auto'>
            <span
              style={{
                borderRadius: 5,
                padding: '2px 8px',
                fontSize: 11,
                fontWeight: 600,
                border: `1px solid ${typeInfo.color}`,
                color: typeInfo.color,
                // backgroundColor: typeInfo.color,
                // color: '#fff',
              }}
            >
              {typeInfo.label}
            </span>
          </Col>
        </Row>
      </div>
    );
  }

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    // Language Direction
    let { lang_orientation: dir } = this.props.defaultLanguage;
    const { authData } = this.props;
    const { role_id } = authData.loginData;
    let center_tags = JSON.parse(authData.loginData.center_tags)

    const regionalStorageURL = getRegionalStorageURL(authData.centerData.tenant_id);

    // State
    const { utWorking, startDate, endDate, utTypes, selectedUtTypes, userTimelineData, loadMore, activityModal, academic_activity, assessmentMenuData, selectedProgass, selectedAgegroup, selectedLearnarea, selectedAspect, curriculum, academic_activity_attachments, academic_activity_questions, questionModal, aa_q_type, academic_activity_question } = this.state;

    const editSkill = this.state.academic_activity_resources.find((v, i) => v.aar_type == 'skill' && v.editing);

    const editExternalResource = this.state.academic_activity_resources.find((v, i) => v.aar_type == 'external_resource' && v.editing);

    const editSuccess = this.state.academic_activity_resources.find((v, i) => v.aar_type == 'success' && v.editing);

    const editLinesOfEnquiry = this.state.academic_activity_resources.find((v, i) => v.aar_type == 'lines_of_enquiry' && v.editing);

    const transdisciplinary_theme = this.state.academic_activity_resources.find((v, i) => v.aar_type == 'transdisciplinary_theme')
    if (transdisciplinary_theme) {
      let find_academicLessonAttributes_transdisciplinary_theme = this.state.academicLessonAttributes.find((v) => (transdisciplinary_theme.aar_type_id == v.ala_id))
      if (find_academicLessonAttributes_transdisciplinary_theme) {
        transdisciplinary_theme.image = find_academicLessonAttributes_transdisciplinary_theme.ala_description_2
      }
    }

    let progassList = [];
    let ageList = [];
    let learnareaList = [];
    let aspectList = [];
    let curriculumList = [];
    let selectedCurriculumList = [];

    if (assessmentMenuData) {
      progassList = assessmentMenuData.progass.map((item) => {
        return {
          ...item,
          label: item.progass_code,
          value: item.progass_id
        }
      });


      if (selectedProgass) {
        ageList = assessmentMenuData.agegroup.filter((item) => {
          return JSON.parse(item.progass_ids).includes(selectedProgass.value)
        }).map((item) => {
          return {
            ...item,
            label: item.agegroup_code,
            value: item.agegroup_id
          }
        });
      }

      if (selectedProgass) {
        learnareaList = assessmentMenuData.learnarea.filter((item) => {
          return item.progass_id == selectedProgass.value;
        }).map((item) => {
          return {
            ...item,
            label: item.learnarea_code,
            value: item.learnarea_id
          }
        });
      }

      if (selectedLearnarea) {
        aspectList = assessmentMenuData.lrnaspect.filter((item) => {
          return item.learnarea_id == selectedLearnarea.value;
        }).map((item) => {
          return {
            ...item,
            label: item.lrnaspect_code,
            value: item.lrnaspect_id
          }
        });
      }

      if (selectedAgegroup && selectedAgegroup) {
        curriculumList = assessmentMenuData.allCurriculum.filter((item) => {
          return JSON.parse(item.agegroup_ids).includes(selectedAgegroup.value) && item.lrnaspect_id == selectedAspect.value && item.progass_id == selectedProgass.progass_id;
        }).map((item) => {
          return {
            ...item,
            label: item.curriculum_code,
            value: item.curriculum_id
          }
        });
      }

      assessmentMenuData.allCurriculum.map((item) => {
        let findSelectedCurriculum = academic_activity.curriculum_ids.findIndex((vv, ii) => vv == item.curriculum_id)
        if (findSelectedCurriculum !== -1) {
          selectedCurriculumList.push(item)
        }
      })

    }

    /****************************************************/
    /*         Dynamic Prompt for AI: Activity          */
    /****************************************************/
    let dynamicAIPrompt = `DATA: Activity Name: ${this.state.academic_activity.aa_name}, Central Idea: ${this.state.academic_activity.aa_desc_cidea}, Curriculum: ${this.state.academic_activity.agegroup_id?.progs}, Age group/Grade level: ${this.state.academic_activity.agegroup_id?.agegroup_code}. `;

    if (selectedCurriculumList.length > 0) {
      dynamicAIPrompt += `, Objectives: ${selectedCurriculumList.map((v) => v.curriculum_code).join(', ')}`;
    }

    // console.log('%cSTATE', 'color: orange; font-size: 20px; font-weight: bold;', this.state);

    return (
      <>
        <Container fluid>
          <div id='iedu-layout'>
            <NavBar />
            <div id='page-content' style={{ padding: (dir == 1) ? '20px 118px 20px 10px' : '20px 10px 20px 118px' }}>
              <Header
                lite={true}
                centerSelectorFunc={[this.resetFilter]}
                classSelectorFunc={[this.calendarList, this.getTodayAtt]}
              // showClassSelector={(center_tags.length > 0) ? true : false} 
              />
              <div className='grey-section m-0' style={{ borderRadius: 35, padding: 15, height: 'calc(100vh - 140px)' }}>
                <Row>
                  <Col md={8}>
                    <Row className='ms-0'>
                      <Col md={3} className='split-btn'>
                        <NavLink to='/subject/lessons'>
                          <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Lessons')}
                        </NavLink>
                        <button onClick={() => this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            show: true,
                          }
                        })}><FontAwesomeIcon icon={faPlus} /></button>
                      </Col>
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3} className='split-btn'>
                          <NavLink to='/exams'>
                            <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Exam Hall')}
                          </NavLink>
                          <button onClick={() => this.setState({ examstypegrp_type: 'Exam' }, () => this.AddEditExam.current.handleShowCreateUpdateExamCanvas())}><FontAwesomeIcon icon={faPlus} /></button>
                        </Col>
                      }
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3} className='split-btn'>
                          <NavLink to='/homework'>
                            <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Homework')}
                          </NavLink>
                          <button onClick={() => this.setState({ examstypegrp_type: 'Homework' }, () => this.AddEditExam.current.handleShowCreateUpdateExamCanvas())}><FontAwesomeIcon icon={faPlus} /></button>
                        </Col>
                      }
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3} className='split-btn'>
                          <NavLink to='/project'>
                            <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Project')}
                          </NavLink>
                          <button onClick={() => this.setState({ examstypegrp_type: 'Project' }, () => this.AddEditExam.current.handleShowCreateUpdateExamCanvas())}><FontAwesomeIcon icon={faPlus} /></button>
                        </Col>
                      }
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3} className='split-btn'>
                          <NavLink to='/assignment'>
                            <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Classwork')}
                          </NavLink>
                          <button onClick={() => this.setState({ examstypegrp_type: 'Assignment' }, () => this.AddEditExam.current.handleShowCreateUpdateExamCanvas())}><FontAwesomeIcon icon={faPlus} /></button>
                        </Col>
                      }
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3} className='split-btn'>
                          <NavLink to='/other-assessment'>
                            <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Other Assessments')}
                          </NavLink>
                          <button onClick={() => this.setState({ examstypegrp_type: 'Other' }, () => this.AddEditExam.current.handleShowCreateUpdateExamCanvas())}><FontAwesomeIcon icon={faPlus} /></button>
                        </Col>
                      }
                      <Col md={3} className='split-btn'>
                        <NavLink to='/activities'>
                          <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Activity')}
                        </NavLink>
                        <button onClick={() => {
                          this.setState({
                            activityModal: {
                              ...this.state.activityModal,
                              show: true,
                            },
                          });
                          this.resetFormActivity();
                        }}><FontAwesomeIcon icon={faPlus} /></button>
                      </Col>
                      <Col md={3} className='split-btn'>
                        <NavLink to='/assigned-activity'>
                          <FontAwesomeIcon color='#7F8184' className='me-1' icon={faEye} /> {t('Assigned Activity')}
                        </NavLink>
                        <button onClick={() => {
                          this.state.userTimelineModal.toggleModal(this.AcademicActivityTimelineType);
                        }}><FontAwesomeIcon icon={faPlus} /></button>
                      </Col>
                    </Row>
                    <div style={{
                      height: 'calc(100vh - 345px)',
                      backgroundColor: '#Ffff',
                      borderRadius: 20,
                      marginBottom: 14,
                      overflow: 'hidden',
                      position: 'relative',
                    }}>
                      <NavLink
                        className='btn btn-warning btn-sm'
                        target='_blank'
                        to={`/subject-rubric-input`}
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          position: 'absolute',
                          top: 6,
                          right: 15
                        }}>
                        <FontAwesomeIcon icon={faFile} className='me-1' /> {t('INPUT RUBRIC')}
                      </NavLink>
                      <Tabs
                        defaultActiveKey="students"
                        id="dash-tabs"
                        bsPrefix="dash-tabs nav nav-tabs"
                      >
                        <Tab eventKey="students" title="Student Details">
                          <div style={{ overflowY: 'auto', height: 'calc(100vh - 395px)' }}>
                            {this.state.students.map((student, index) => (
                              <div key={index} style={{ borderBottom: '1px solid #DEE2E6', }}>
                                <div
                                  className='d-flex'
                                  style={{
                                    padding: '10px 7px 10px 15px',
                                  }}>
                                  <div style={{
                                    width: 250,
                                    fontSize: 14
                                  }}
                                    className='d-flex align-items-center flex-row'>
                                    {!student.modified ?
                                      <div style={{ width: 12, height: 12, borderRadius: 6, backgroundColor: 'red', marginRight: 7 }}></div>
                                      :
                                      <div style={{ width: 12, height: 12, borderRadius: 6, backgroundColor: '#b7e543', marginRight: 7 }}></div>
                                    }
                                    {student.child_name}
                                  </div>
                                  <div
                                    className='d-flex align-items-center'
                                    style={{
                                      color: '#6E7179',
                                      width: 250,
                                      fontSize: 14
                                    }}>{student.parent_name}</div>
                                  <div className='d-flex align-items-center justify-content-end flex-grow-1'>
                                    {student.gender == 'M'
                                      ? <FontAwesomeIcon
                                        className='me-3' alt='' width={30}
                                        data-tooltip-id="tooltip"
                                        data-tooltip-content={t('Gender: Male')}
                                        data-tooltip-place="top"
                                        icon={faPerson} color={brand_colors[this.props.defaultTheme.theme_id].color1} style={{ fontSize: 22 }} />
                                      : <FontAwesomeIcon
                                        className='me-3' alt='' width={30}
                                        data-tooltip-id="tooltip"
                                        data-tooltip-content={t('Gender: Female')}
                                        data-tooltip-place="top"
                                        icon={faPersonDress} color={brand_colors[this.props.defaultTheme.theme_id].color2} style={{ fontSize: 22 }} />
                                    }
                                    <Button variant="outline-success"
                                      style={{
                                        width: 30,
                                        height: 30,
                                        padding: 0,
                                        marginRight: 5,
                                      }}
                                      onClick={() => {
                                        const students = [...this.state.students];
                                        students[index].showMoreInfo = !students[index].showMoreInfo;
                                        this.setState({ students });
                                      }}>
                                      <FontAwesomeIcon icon={faInfo} />
                                    </Button>
                                    <NavLink className='btn btn-success d-flex align-items-center justify-content-center'
                                      to={`/report-student-integrity?id=` + student.child_id}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        padding: 0,
                                        marginRight: 5,
                                      }}>
                                      <FontAwesomeIcon icon={faChartPie} />
                                    </NavLink>
                                    <Button variant="warning"
                                      onClick={() => this.mailCredentials(student)}
                                      title={t('Mail Credentials')}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        padding: 0,
                                        marginRight: 5,
                                      }}>
                                      <FontAwesomeIcon icon={faShare} />
                                    </Button>
                                    {/* <Button variant="warning"
                                      style={{
                                        width: 30,
                                        height: 30,
                                        padding: 0,
                                      }}>
                                      <FontAwesomeIcon icon={faStar} />
                                    </Button> */}
                                  </div>
                                </div>
                                {student.showMoreInfo &&
                                  <div>
                                    <div className='d-flex' style={{
                                      padding: '5px 15px 10px 15px',
                                      fontSize: 14
                                    }}>
                                      <div style={{ width: '20%' }}>
                                        <strong>{t('Age')}</strong><br />
                                        {this.getStudentAge(student)}
                                      </div>
                                      <div style={{ width: '20%' }}>
                                        <strong>{t('Student Username')}</strong><br />
                                        <div className='username_password'>{student.user_name}</div>
                                      </div>
                                      <div style={{ width: '20%' }}>
                                        <strong>{t('Student Password')}</strong><br />
                                        <div className='username_password'>{student.user_pass}</div>
                                      </div>
                                      <div style={{ width: '20%' }}>
                                        <strong>{t('Parent Username')}</strong><br />
                                        <div className='username_password'>{student.parent_user_name}</div>
                                      </div>
                                      <div style={{ width: '20%' }}>
                                        <strong>{t('Parent Password')}</strong><br />
                                        <div className='username_password'>{student.parent_password}</div>
                                      </div>
                                    </div>
                                    <div style={{
                                      backgroundColor: '#F9F9F9',
                                      border: '#E3E3E3 1px solid',
                                      margin: 10,
                                      borderRadius: 5,
                                      fontSize: 13,
                                    }}>
                                      <div
                                        className='d-flex'
                                        style={{
                                          padding: '10px 10px 0',
                                        }}>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Date of Birth')}</strong><br />
                                          {moment(student.birth_date).format('DD/MM/YYYY')}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Email')}</strong><br />
                                          {student.email1}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Email 2')}</strong><br />
                                          {student.email2}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Phone')}</strong><br />
                                          {student.phone1}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Phone 2')}</strong><br />
                                          {student.phone2}
                                        </div>
                                      </div>
                                      <div
                                        className='d-flex'
                                        style={{
                                          padding: 10,
                                        }}>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Emergency Contact')}</strong><br />
                                          {student.emergency_contact_name}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Emergency Contact')}</strong><br />
                                          {student.emergency_phone1}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Spouse Name')}</strong><br />
                                          {student.spouse_name}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Phone')}</strong><br />
                                          {student.phone1}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                          <strong>{t('Spouse Phone')}</strong><br />
                                          {student.spouse_phone}
                                        </div>
                                      </div>
                                      {student.medical_note &&
                                        <div style={{
                                          backgroundColor: '#EFE3E3',
                                          padding: 10,
                                        }}>
                                          <strong>{t('Medical Note')}</strong><br />
                                          {student.medical_note}
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            ))}
                          </div>
                        </Tab>
                        <Tab eventKey="gradebook" title="Gradebook">
                          <GradeBookWidget2 />
                        </Tab>
                      </Tabs>
                    </div>
                    <Row>
                      <Col md={3} className='pe-0'>
                        <NavLink className='teacher-dash-cta-btn' to='/weekly-class-plan'>
                          {t('Weekly Class Plan')}
                          <img src={require('../../assets/images/image-3.png')} alt={t('Weekly Class Plan')} />
                        </NavLink>
                      </Col>
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3} className='pe-0'>
                          <NavLink className='teacher-dash-cta-btn' to='/class-blog'>
                            {t('Class Blog')}
                            <img src={require('../../assets/images/image-1.png')} alt={t('Class Blog')} />
                          </NavLink>
                        </Col>
                      }
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3} className='pe-0'>
                          <NavLink className='teacher-dash-cta-btn' to='/analysis-reports' target='_blank'>
                            {t('Analysis Reports')}
                            <img src={require('../../assets/images/image-2.png')} alt={t('Analysis Reports')} />
                          </NavLink>
                        </Col>
                      }
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Col md={3}>
                          <NavLink className='teacher-dash-cta-btn' to={this.state.weeklyLessonPlanLink}>
                            {t('Weekly Lesson Plan')}
                            <img src={require('../../assets/images/image-3.png')} alt={t('Weekly Lesson Plans')} />
                          </NavLink>
                        </Col>
                      }
                    </Row>
                  </Col>
                  <Col md={'auto'}
                    style={{
                      width: 1,
                      backgroundColor: '#CCCCCC',
                      padding: 0,
                    }}></Col>
                  <Col>
                    <div
                      className="hide-scrollbar"
                      style={{
                        height: 'calc(100vh - 172px)',
                        overflowY: 'auto',
                        borderBottomRightRadius: 20,
                      }}>
                      {![0, 1].includes(this.props.selectedClass.class.gcycle_id) &&
                        <Row style={{
                          marginBottom: 15
                        }}>
                          <Col md={4} className='pe-0'>
                            <NavLink className='teacher-dash-cta-btn' to='/cas'>
                              {t('CAS')}
                              <img src={require('../../assets/images/cta-1.png')} alt={t('CAS')} />
                            </NavLink>
                          </Col>
                          <Col md={4} className='pe-0'>
                            <NavLink className='teacher-dash-cta-btn' to='/essay'>
                              {t('Essay')}
                              <img src={require('../../assets/images/cta-2.png')} alt={t('Essay')} />
                            </NavLink>
                          </Col>
                          <Col md={4}>
                            <NavLink className='teacher-dash-cta-btn' to='/tok/tok-topics'>
                              {t('TOK')}
                              <img src={require('../../assets/images/cta-3.png')} alt={t('TOK')} />
                            </NavLink>
                          </Col>
                        </Row>
                      }
                      <div
                        style={{
                          background: '#fff',
                          borderRadius: 20,
                          padding: 15,
                          marginBottom: 15,
                          paddingTop: 12
                        }}>
                        <Row>
                          <Col><h6 className='mb-3'>{t('Class Attendance')}</h6></Col>
                          <Col className='text-end'>
                            <Link to={[27, 2].includes(this.props.authData.userData.role_id) ? '/students/custom-attendance' : '/students/attendance'}>
                              <FontAwesomeIcon
                                icon={faUpRightFromSquare} color='#538DEE' />
                            </Link>
                          </Col>
                        </Row>
                        {this.state.todayAtt && this.renderClassAtt()}
                      </div>
                      <div
                        style={{
                          background: '#fff',
                          borderRadius: 20,
                          padding: 15,
                          paddingTop: 12,
                          marginBottom: 15
                        }}>
                        <Row>
                          <Col><h6 className='mb-3'>{t('Tasks')}</h6></Col>
                          <Col className='text-end'>
                            <span style={{
                              backgroundColor: '#E7E8E9',
                              borderRadius: 5,
                              fontSize: 12,
                              display: 'inline-block',
                              padding: '4px 7px',
                              marginRight: 10,
                              position: 'relative',
                              top: -2
                            }}>
                              <FontAwesomeIcon icon={faCalendar} className='me-1' />
                              <strong>{moment().format('dddd')}</strong>, {' ' + moment().format('D MMM YYYY')}
                            </span>
                            <Link to={'/calendar'}>
                              <FontAwesomeIcon
                                icon={faUpRightFromSquare} color='#538DEE' />
                            </Link>
                          </Col>
                        </Row>
                        <div style={{ backgroundColor: '#F3F3F3', padding: 5, borderRadius: 10, minHeight: 150 }}>
                          {!this.state.calendarList &&
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 150, color: '#999', fontSize: 16 }}>
                              {t('No tasks for today')}
                            </div>
                          }
                          {this.state.calendarList?.length > 0 && this.state.calendarList.map((item, index) => this.renderDailyTask(item, index)
                          )}
                        </div>
                      </div>
                      <Timetable2 />
                    </div>
                  </Col>
                </Row>
              </div>

              {/* <Timetable />
                <Row>
                  {![27, 2].includes(role_id) &&
                    <Col md={4}>
                      <div className='widget-box' style={{
                        marginBottom: 23
                      }}>
                        <Link to='/calendar' className='widget-box-header'>
                          <Row>
                            <Col md={1} className='pe-0' style={{ textAlign: dir == 1 ? 'left' : 'right' }}>
                              <FontAwesomeIcon icon={faCalendar} style={{ color: '#fff', marginRight: 7 }} />
                            </Col>
                            <Col style={{ textAlign: dir == 1 ? 'right' : 'left', fontWeight: 700, color: '#fff' }}>{moment().format('dddd, D MMM YYYY')}</Col>
                            <Col md={'auto'}>
                              <FontAwesomeIcon icon={dir == 1 ? faChevronLeft : faChevronRight} style={{ color: '#fff', marginRight: 7 }} />
                            </Col>
                          </Row>
                        </Link>
                        <div className='widget-box-body'>
                          {!this.state.calendarList &&
                            <div style={{ paddingTop: 50, textAlign: 'center' }}>
                              <Spinner animation="grow" />
                            </div>
                          }
                          {this.state.calendarList?.length == 0 &&
                            <div style={{ paddingTop: 50, textAlign: 'center' }}>
                              {t('No Data Found!')}
                            </div>
                          }
                          {this.state.calendarList?.length > 0 &&
                            <div className='widget-box-list'>
                              {this.state.calendarList.map((item, index) => {
                                const body = item.body.replace(/(<([^>]+)>)/gi, "");
                                return (
                                  <div key={index} className={dir == 1 ? 'widget-box-list-item-ar' : 'widget-box-list-item'}>
                                    {item.title} - {body.length > 50 ? body.substring(0, 50) + '...' : body}
                                  </div>
                                )
                              }
                              )}
                            </div>
                          }
                        </div>
                      </div>
                    </Col>
                  }
                  <Col md={4}>
                    <div className='widget-box'>
                      <Link to={[27, 2].includes(this.props.authData.userData.role_id) ? '/students/custom-attendance' : '/students/attendance'} className='widget-box-header'>
                        <Row>
                          <Col md={1} className='pe-0' style={{ textAlign: dir == 1 ? 'left' : 'right' }}>
                            <FontAwesomeIcon icon={faUserCheck} style={{ color: '#fff', marginRight: 7 }} />
                          </Col>
                          <Col style={{ textAlign: dir == 1 ? 'right' : 'left', fontWeight: 700, color: '#fff' }}>{t("Class Attendance")}</Col>
                          <Col md={'auto'}>
                            <FontAwesomeIcon icon={dir == 1 ? faChevronLeft : faChevronRight} style={{ color: '#fff', marginRight: 7 }} />
                          </Col>
                        </Row>
                      </Link>
                      <div className='widget-box-body'>
                        {!this.state.todayAtt &&
                          <div style={{ paddingTop: 50, textAlign: 'center' }}>
                            <Spinner animation="grow" />
                          </div>
                        }
                        <div style={{
                          paddingTop: 15,
                          paddingRight: '10%'
                        }}>
                          {this.state.todayAtt && <Doughnut
                            data={this.state.todayAtt}
                            options={doughnutChartOptions}
                            height={110}
                          />}
                        </div>
                      </div>
                    </div>
                  </Col>

                  {[3, 15, 19, 22].includes(role_id) &&
                    <Col md={4}>
                      <div className='widget-box' style={{
                        marginBottom: 23
                      }}>
                        <Link to='/early-childhood' className='widget-box-full-btn'>
                          <FontAwesomeIcon
                            icon={faPuzzlePiece}
                            color={'#fff'}
                            style={{
                              fontSize: 60,
                              marginBottom: 10
                            }}
                          />
                          {t('Objectives & Journals')}
                        </Link>
                      </div>
                    </Col>
                  }

                  {[1, 3, 12, 15, 19, 22].includes(role_id) &&
                    <Col md={12}>
                      <ExamsHomeworksWidget size={'sm'} />
                    </Col>
                  }
                </Row>
                <Row>
                  {[27, 2].includes(role_id) &&
                    <Col md={4}>
                      <div className='widget-box' style={{ marginBottom: 23, marginTop: 23, height: 'auto' }}>
                        <SchoolAttendanceWidget />
                      </div>
                    </Col>
                  }
                </Row> */}


              {/* <div className='slider-wrap two-slider' style={{}}>
                  <Slider {...twoSliderSettings}>
                    <div className='two-slide'>
                      <div className='slide-inner'>
                        <Link to='/calendar'>
                          <div className='slide-icon'>
                            <FontAwesomeIcon
                              icon={faCalendarAlt}
                              color={brand_colors[this.props.defaultTheme.theme_id].color8}
                            />
                          </div>
                          <h6>{t('Main')}</h6>
                          <span>{t('Calendar')}</span>
                        </Link>
                      </div>
                    </div>
                    <div className='two-slide'>
                      <div className='slide-inner'>
                        <Link to='/exam-calendar'>
                          <div className='slide-icon'>
                            <FontAwesomeIcon
                              icon={faCalendarDay}
                              color={brand_colors[this.props.defaultTheme.theme_id].color8}
                            />
                          </div>
                          <h6>{t('Exam')}</h6>
                          <span>{t('Calendar')}</span>
                        </Link>
                      </div>
                    </div>
                    <div className='two-slide'>
                      <div className='slide-inner'>
                        <Link to='/timetable'>
                          <div className='slide-icon'>
                            <FontAwesomeIcon
                              icon={faTable}
                              color={brand_colors[this.props.defaultTheme.theme_id].color8}
                            />
                          </div>
                          <h6>{t('Student')}</h6>
                          <span>
                            {t('Timetable')}
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className='two-slide'>
                      <div className='slide-inner'>
                        <Link to='/analysis'>
                          <div className='slide-icon'>
                            <FontAwesomeIcon
                              icon={faChartBar}
                              color={brand_colors[this.props.defaultTheme.theme_id].color8}
                            />
                          </div>
                          <h6>{t('Analysis')}</h6>
                          <span>{t('Detail')}</span>
                        </Link>
                      </div>
                    </div>
                  </Slider>
                </div> */}

              {/* CAS, Essay */}
              {false && [3, 4, 15, 22].includes(role_id) &&
                <div className="d-flex flex-row  align-items-center flex-wrap">
                  {ifNavAllowed('cas') &&
                    <div className='one-slide mt-4 d-flex' style={{ width: '25%' }}>
                      <Link to="/cas" style={{ width: '100%' }}>
                        <div className='slide-inner' style={{ backgroundColor: '#15bbe7' }}>
                          <h3>{t('CAS')}</h3>
                          <div style={{ flex: 1 }}></div>
                          <img src={require('../../assets/images/person-2.png')} alt='' />
                        </div>
                      </Link>
                    </div>
                  }
                  {ifNavAllowed('essay') &&
                    <div className='one-slide mt-4 d-flex' style={{ width: '25%' }}>
                      <Link to="/essay" style={{ width: '100%' }}>
                        <div className='slide-inner' style={{ backgroundColor: '#8864ed' }}>
                          <h3>{t('Essay')}</h3>
                          <div style={{ flex: 1 }}></div>
                          <img src={require('../../assets/images/person-1.png')} alt='' />
                        </div>
                      </Link>
                    </div>
                  }
                  {ifNavAllowed('tok') &&
                    <div className='one-slide mt-4 d-flex' style={{ width: '25%' }}>
                      <Link to="/tok/tok-topics" style={{ width: '100%' }}>
                        <div className='slide-inner' style={{ backgroundColor: '#8864ed' }}>
                          <h3>{t('TOK')}</h3>
                          <div style={{ flex: 1 }}></div>
                          <img src={require('../../assets/images/person-1.png')} alt='' />
                        </div>
                      </Link>
                    </div>
                  }
                  {ifNavAllowed('grade-book-detail-lite') &&
                    <div className='one-slide mt-4 d-flex' style={{ width: '25%' }}>
                      <Link to="/grade-book-detail-lite" style={{ width: '100%' }}>
                        <div className='slide-inner' style={{ backgroundColor: '#15bbe7' }}>
                          <h3>{t('Grade Book')}</h3>
                          <div style={{ flex: 1 }}></div>
                          <img src={require('../../assets/images/person-2.png')} alt='' />
                        </div>
                      </Link>
                    </div>
                  }
                </div>
              }

              {/* SUBJECTS */}
              {false && ![27, 2].includes(role_id) &&
                <div className='slider-wrap' style={{ padding: '10px 0' }} >
                  <Subjects hideHeader={true} agegroup_id={this.props.selectedClass.class.agegroup_id} />
                </div>
              }
            </div>
          </div>
        </Container >

        <Offcanvas
          id='dashboard-ut'
          show={this.state.showUT} onHide={this.handleCloseUT} placement={(dir == 1) ? 'start' : 'end'}>
          <Offcanvas.Body className='p-0'>
            <Timeline
              utWorking={utWorking}
              utTypes={utTypes}
              selectedUtTypes={selectedUtTypes}
              startDate={startDate}
              endDate={endDate}
              handleUtDateRange={this.handleUtDateRange}
              handleSelectUtTypes={this.handleSelectUtTypes}
              getTimeline={this.getTimeline}
              resetFilter={this.resetFilter}
              applyFilter={this.applyFilter}
              userTimelineData={userTimelineData}
              loadMore={loadMore}
              handleCloseUT={this.handleCloseUT}
            />
          </Offcanvas.Body>
        </Offcanvas>

        <button
          onClick={this.handleOpenUT}
          title={t('Open News Feed')}
          className='ut-toggle'>
          <FontAwesomeIcon icon={(dir == 1) ? faAngleRight : faAngleLeft} />
        </button>

        <Modal
          backdrop="static"
          keyboard={false}
          size='lg'
          show={this.state.lessonModal.show}
          onHide={this.state.lessonModal.close}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t('New Lesson')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='custom-styled-form'>
              <Row>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('Name')}
                    </Form.Label>
                    <Form.Control
                      type='text'
                      value={this.state.lessonModal.data.name}
                      onChange={(event) =>
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              name: event.target.value
                            }
                          }
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('Code')}
                    </Form.Label>
                    <Form.Control
                      type='text'
                      value={this.state.lessonModal.data.code}
                      onChange={(event) =>
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              code: event.target.value
                            }
                          }
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('URL')}
                    </Form.Label>
                    <Form.Control
                      type='text'
                      value={this.state.lessonModal.data.url}
                      onChange={(event) =>
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              url: event.target.value
                            }
                          }
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('Period')}
                    </Form.Label>
                    <Form.Control
                      type='number'
                      value={this.state.lessonModal.data.period}
                      onChange={(event) =>
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              period: event.target.value
                            }
                          }
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Theme')}</Form.Label>
                    <Form.Control
                      type='text'
                      value={this.state.lessonModal.data.theme}
                      onChange={(event) =>
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              theme: event.target.value
                            }
                          }
                        })
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Folder')}</Form.Label>
                    <Select isClearable
                      placeholder={t('Select folder')}
                      value={this.state.lessonModal.data.aslf_id}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (
                          base
                        ) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.lessonFolders}
                      onChange={(obj) => {
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              aslf_id: obj
                            }
                          }
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Default Term')}</Form.Label>
                    <Select isClearable
                      placeholder={t('Select Default Term')}
                      value={this.state.lessonModal.data.term_d_id}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (
                          base
                        ) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.termsDefault}
                      onChange={(obj) => {
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              term_d_id: obj
                            }
                          }
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group controlId='file3' className='mb-3'>
                    <Form.Label>
                      {t('Image')}
                    </Form.Label>
                    <div style={{ flexDirection: 'column', }} className='pic-prev d-flex justify-content-center'>
                      <div style={{ borderRadius: 5, borderStyle: 'solid', borderWidth: 1, borderColor: '#ced4da', height: 158, display: 'flex', overflow: 'hidden', }}>
                        {(this.state.lessonModal.data.image !== '' && this.state.lessonModal.data.image_prev !== '') ? (
                          <div className='d-flex justify-content-center align-items-center' style={{ flex: 1, position: 'relative', }}>
                            <button style={{ padding: 3, border: 3, background: 'none', position: 'absolute', top: 0, right: 0, }}
                              onClick={() => {
                                this.setState({
                                  lessonModal: {
                                    ...this.state.lessonModal,
                                    data: {
                                      ...this.state.lessonModal.data,
                                      image: '',
                                      image_prev: ''
                                    }
                                  }
                                })
                                this.lessonImage.current.value =
                                  null
                              }}>
                              <FontAwesomeIcon
                                icon={
                                  faTimesCircle
                                }
                                color='rgb(220, 53, 69)'
                                style={{
                                  fontSize: 20,
                                }}
                              />
                            </button>
                            <img
                              src={this.state.lessonModal.data.image_prev}
                              alt={t('Preview')}
                              width='100'
                            />
                          </div>
                        ) : (
                          <button
                            onClick={() =>
                              this.lessonImage.current.click()
                            }
                            style={{
                              background: 'none',
                              border: 0,
                              flex: 1,
                            }}>
                            <FontAwesomeIcon
                              className='file-selector'
                              icon={faPlus}
                              style={{
                                fontSize: 30,
                              }}
                            />
                          </button>
                        )}
                      </div>
                      <Form.Control
                        className='d-none'
                        ref={this.lessonImage}
                        type='file'
                        onChange={this.setLessonImage}
                        name='image'
                        accept='.jpg, .jpeg, .png'
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      {t('Central Idea')}
                    </Form.Label>
                    <Form.Control
                      as='textarea'
                      rows={6}
                      onChange={(event) =>
                        this.setState({
                          lessonModal: {
                            ...this.state.lessonModal,
                            data: {
                              ...this.state.lessonModal.data,
                              note1: event.target.value
                            }
                          }
                        })
                      }
                      value={this.state.lessonModal.data.note1}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant='secondary'
              onClick={this.state.lessonModal.close}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.lessonModal.working}
              variant='primary'
              onClick={this.insertLesson}>
              {t('Add Lesson')}{' '}
              {this.state.lessonModal.working && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <AddEditExam
          ref={this.AddEditExam}
          authData={this.props.authData}
          examstypegrp_type={this.state.examstypegrp_type}
          selectedClass={this.props.selectedClass}
          selectedSubject={this.props.selectedSubject}
          callBack={() => { }}
          defaultTheme={this.props.defaultTheme}
        />

        {this.renderFormAcademicActivity()}

        {/* ACTIVITY MODAL - Ahmad  */}
        <Offcanvas show={this.state.activityModal.show} onHide={this.state.activityModal.closeModal} style={{ height: '100%' }} placement='bottom'>
          <Offcanvas.Header id='iedu-header' style={{ marginTop: '1rem', marginRight: '1rem', marginLeft: '1rem', marginBottom: 0 }}>
            <div className='d-flex flex-row'>
              <span className='header-back-btn' onClick={activityModal.closeModal} style={{ marginRight: 10 }}>
                <FontAwesomeIcon icon={faArrowAltCircleLeft} color={brand_colors[this.props.defaultTheme.theme_id].color9} />
              </span>
              <Offcanvas.Title>{t('Add Activity')}</Offcanvas.Title>
            </div>
            <div>
              <Button disabled={this.state.activityModal.working} variant='success' onClick={() => this.saveActivity()}>
                {t('Save')} {this.state.activityModal.working ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' /> : ''}
              </Button>
            </div>
          </Offcanvas.Header>
          {activityModal.show &&
            <Offcanvas.Body>
              <div
                className={'d-flex flex-row grey-section'}
                style={{
                  overflow: 'hidden',
                  backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7
                }}
              >
                <div style={{ marginLeft: 5, marginRight: 5, borderRadius: '20px', width: '320px', height: '74vh', overflow: 'auto' }}>
                  <div className='pe-2 pt-3'>
                    {this.state.formSectionsActivity.map((v, i) => {
                      let thisCompleted = v.data.filter((vv) => {
                        return vv.completed
                      }).length
                      return <div key={i} className="d-flex flex-column p-2 mb-2 cursor-pointer" style={{ backgroundColor: (v.uid == this.state.formSectionActive.parent) ? '#e1eff5' : brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 5, border: (v.uid == this.state.formSectionActive.parent) ? 'solid 1px #43bdea' : 'solid 1px #fff' }} onClick={() => this.changeToFromSection(v.uid, v.uid + '.1')}>
                        <div className="d-flex flex-row">
                          <div style={{ height: 50, width: 50, overFlow: 'hidden', borderRadius: 5 }}>
                            <img src={v.image} alt={t('Preview')} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                          </div>
                          <div className="d-flex flex-column justify-content-center px-2" style={{ flex: 1, fontSize: 14 }}>
                            <div style={{ fontWeight: 600 }}>{v.name}</div>
                            <div style={{ color: (v.uid == this.state.formSectionActive.parent) ? '#9ea7aa' : '#c5c5c5' }}>{v.desc}</div>
                          </div>
                          <div>
                            <FontAwesomeIcon icon={faAngleRight} />
                          </div>
                        </div>
                        <div className="mt-3 mb-1">
                          <div className="d-flex flex-row align-items-center justify-content-center" style={{ width: '100%' }}>
                            <div style={{ flex: 1 }} className="d-flex flex-row align-items-center justify-content-center">

                              <div style={{ height: 5, borderRadius: 5, width: '100%', backgroundColor: (v.uid == this.state.formSectionActive.parent) ? '#d5e1e7' : '#f0f0f0', overFlow: 'hidden' }}>
                                <div style={{ width: (thisCompleted / v.data.length) * 100 + '%', height: 5, backgroundColor: '#468bee' }}>
                                </div>
                              </div>
                            </div>
                            <div className="ps-2" style={{ color: (v.uid == this.state.formSectionActive.parent) ? '#9ea7aa' : '#c5c5c5' }}>
                              {thisCompleted}{'/'}
                              {v.data.length}
                            </div>
                          </div>

                        </div>
                      </div>
                    })}
                  </div>
                </div>
                <Col className='custom-styled-form hide-scrollbar position-relative' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, marginLeft: 10, marginRight: 10, borderRadius: '20px', overflow: 'auto', height: '74vh' }}>
                  {/* SECTION 1 */}
                  {this.state.formSectionActive.parent == '1' && (
                    <div id='form_section_1'>
                      {/* ACTIVITY */}
                      <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }}>
                        <span className='heading'>{'Activity'} </span>
                      </div>
                      <div className='p-2'>
                        <div className="d-flex flex-row" style={{ width: '100%' }}>
                          <div id='form_section_1.6'>
                            <div style={{ flexDirection: 'column' }} className='pic-prev d-flex justify-content-center position-relative'>
                              <div style={{ minHeight: 190, minWidth: 190, height: 190, width: 190, overflow: 'hidden', borderStyle: 'dashed', borderColor: '#b3b3b3', borderWidth: 1, borderRadius: 10, position: 'relative', backgroundColor: '#f8f8f8' }} className='d-flex justify-content-center align-items-center'>
                                {this.state.aa_image ? (
                                  <img src={this.state.aa_image.url} alt={t('Preview')} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                ) : (
                                  <button onClick={() => this.aa_image_ref.current.click()} style={{ background: 'none', border: 0, flex: 1 }}>
                                    <FontAwesomeIcon icon={faCamera} style={{ fontSize: 24, color: '#999999' }} />
                                    <div style={{ color: '#999999', fontSize: 12 }}>{t('Upload Image')}</div>
                                  </button>
                                )}

                                {this.state.aa_image && (
                                  <FontAwesomeIcon
                                    icon={faTrashCan}
                                    style={{ fontSize: 16, color: brand_colors[this.props.defaultTheme.theme_id].color11, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 100, padding: 3 }}
                                    onClick={() => {
                                      this.setState({ aa_image: null }, () => this.checkCompletedFormSectionsActivity());
                                    }}
                                  />
                                )}
                              </div>
                              <Form.Control className='d-none' ref={this.aa_image_ref} type='file' onChange={this.addActivityAttachment} name='aa_image' />
                            </div>
                          </div>
                          <div className="d-flex flex-column ms-3" style={{ flex: 1 }}>
                            <div className="d-flex flex-row mb-3">
                              <div style={{ flex: 1 }} className='me-1'>
                                <Form.Group id='form_section_1.1'>
                                  <Form.Label>
                                    {t('Activity Name')}
                                  </Form.Label>
                                  <Form.Control type='text' value={academic_activity.aa_name} onChange={(event) => this.setStateAcademicActivity('aa_name', event.target.value)} />
                                </Form.Group>
                              </div>
                              <div style={{ flex: 1 }} className='ms-1 me-1'>
                                <Form.Group id='form_section_1.9'>
                                  <Form.Label>
                                    {t('Default Terms')}
                                  </Form.Label>
                                  <Select
                                    isMulti
                                    closeMenuOnSelect={false}
                                    options={this.state.termsDefault}
                                    onChange={(event) => this.setStateAcademicActivity('term_d_ids', event)}
                                    value={academic_activity.term_d_ids}
                                  />
                                </Form.Group>
                              </div>
                              <div style={{ flex: 1 }} className='ms-1'>
                                <Form.Group id='form_section_1.10'>
                                  <Form.Label>
                                    {t('Grade')}
                                  </Form.Label>
                                  <Select
                                    options={this.state.agegroups}
                                    onChange={(event) => {
                                      this.setStateAcademicActivity('agegroup_id', event);
                                    }}
                                    value={academic_activity.agegroup_id}
                                  />
                                </Form.Group>
                              </div>
                            </div>
                            <div >
                              <Form.Group className='mb-3' id='form_section_1.2'>
                                <Form.Label>
                                  {t('Central Idea')}
                                </Form.Label>
                                <Form.Control as="textarea" rows={3} onChange={(event) => this.setStateAcademicActivity('aa_desc_cidea', event.target.value)} value={academic_activity.aa_desc_cidea} />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-row mb-3" style={{ width: '100%' }}>
                          <div className="me-2" style={{ flex: 1 }}>
                            <Form.Group id='form_section_1.3'>
                              <Form.Label>
                                {t('Activity Design')}
                              </Form.Label>
                              <Form.Control as="textarea" rows={3} onChange={(event) => this.setStateAcademicActivity('aa_desc', event.target.value)} value={academic_activity.aa_desc} />
                            </Form.Group>
                          </div>
                          <div className="ms-2" style={{ flex: 1 }}>
                            <Form.Group id='form_section_1.4'>
                              <Form.Label>
                                {t('General Description')}
                              </Form.Label>
                              <Form.Control as="textarea" rows={3} onChange={(event) => this.setStateAcademicActivity('aa_desc_general', event.target.value)} value={academic_activity.aa_desc_general} />
                            </Form.Group>
                          </div>
                        </div>
                        <div className="d-flex flex-row" style={{ width: '100%' }}>
                          <div style={{ flex: 1 }}>
                            <Form.Group id='form_section_1.5'>
                              <Form.Label>
                                {t('Unit')}
                              </Form.Label>
                              <Form.Control as="textarea" rows={3} onChange={(event) => this.setStateAcademicActivity('aa_desc_unit', event.target.value)} value={academic_activity.aa_desc_unit} />
                            </Form.Group>
                          </div>
                        </div>
                      </div>

                      {/* Objectives */}
                      <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} id='form_section_1.7'>
                        <span className='heading'>{'Objectives'}</span>
                      </div>
                      <div className='d-flex flex-row px-2'>
                        <div className={(this.state.activeObsTab == 'Observation') ? 'btn-tab-item cursor-pointer active' : 'btn-tab-item cursor-pointer'}
                          onClick={() => this.setState({ activeObsTab: 'Observation' })}>
                          <FontAwesomeIcon icon={faClipboard} className='me-1' />
                          {'Details'}
                        </div>
                        <div className={(this.state.activeObsTab == 'SelectedObservation') ? 'btn-tab-item cursor-pointer active' : 'btn-tab-item cursor-pointer'}
                          onClick={() => this.setState({ activeObsTab: 'SelectedObservation', })}>
                          <FontAwesomeIcon icon={faClipboardCheck} className='me-1' />
                          {'Added Observation'}
                        </div>
                      </div>
                      {(this.state.activeObsTab == 'Observation')
                        ? <div className='d-flex flex-row p-2' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 10 }}>
                          <div style={{ flex: 1 }}>
                            <div className='d-flex flex-column'>
                              {/* PROGASS */}
                              {progassList && progassList.map((progass, progass_i) => {
                                return (
                                  <div key={progass_i} className="d-flex flex-column">
                                    <div className='d-flex flex-row justify-content-between align-items-center ps-2 py-2 cursor-pointer' title={progass.progass_desc}
                                      style={{ fontSize: 14, fontWeight: '600' }}
                                      onClick={() => this.onChangeProgass(progass)}>
                                      <div style={{ flex: 1 }}>{progass.progass_code}</div>
                                      <div style={{ width: 50 }} className='text-center'>
                                        <FontAwesomeIcon icon={(selectedProgass && progass.value == selectedProgass.value) ? faAngleUp : faAngleDown} />
                                      </div>
                                    </div>
                                    {/* LEARNAREA */}
                                    <div className='ms-2' style={{ borderLeft: 'solid 1px #ced4da' }}>
                                      {(selectedProgass && selectedProgass.progass_id == progass.progass_id && learnareaList) && learnareaList.map((learnarea, learnarea_i) => {
                                        return (
                                          <div key={learnarea_i} className="d-flex flex-column">
                                            <div className='d-flex flex-row justify-content-between align-items-center ps-4 py-2 cursor-pointer' title={learnarea.learnarea_desc}
                                              style={{ fontSize: 14, fontWeight: '600', position: 'relative' }}
                                              onClick={() => this.onChangeLearnArea(learnarea)}>
                                              <div style={{ flex: 1, color: (selectedLearnarea && selectedLearnarea.value == learnarea.value) ? brand_colors[this.props.defaultTheme.theme_id].color9 : learnarea.learnarea_color }}>{learnarea.learnarea_code}</div>
                                              <div style={{ width: 50 }} className='text-center'>
                                                <FontAwesomeIcon icon={(selectedLearnarea && selectedLearnarea.value == learnarea.value) ? faAngleUp : faAngleDown} />
                                              </div>
                                              <div style={{ borderLeft: '1px solid rgb(206, 212, 218)', height: '25px', width: '20px', borderBottomLeftRadius: '18px', position: 'absolute', left: '-1px', bottom: '17px', borderBottom: '1px solid rgb(206, 212, 218)' }}></div>
                                            </div>

                                            {/* LRNASPECT */}
                                            <div className='ms-4' style={{ borderLeft: 'solid 1px #ced4da' }}>
                                              {(selectedLearnarea && selectedLearnarea.value == learnarea.value && aspectList) && aspectList.map((lrnaspect, lrnaspect_i) => {
                                                return (
                                                  <div key={lrnaspect_i} className="d-flex flex-column">
                                                    <div className='d-flex flex-row justify-content-between align-items-center ps-4 py-2 cursor-pointer' title={lrnaspect.lrnaspect_desc}
                                                      style={{ fontSize: 14, fontWeight: '600', position: 'relative' }}
                                                      onClick={() => this.onChangeAspect(lrnaspect)}>
                                                      <div style={{ flex: 1 }}>{lrnaspect.lrnaspect_code}</div>
                                                      <div style={{ width: 50 }} className='text-center'>
                                                        <FontAwesomeIcon icon={(selectedAspect && selectedAspect.value == lrnaspect.value) ? faAngleUp : faAngleDown} />
                                                      </div>
                                                      <div style={{ borderLeft: '1px solid rgb(206, 212, 218)', height: '25px', width: '20px', borderBottomLeftRadius: '18px', position: 'absolute', left: '-1px', bottom: '17px', borderBottom: '1px solid rgb(206, 212, 218)' }}></div>
                                                    </div>

                                                    {/* AGEGROUP */}
                                                    <div className='ms-4' style={{ borderLeft: 'solid 1px #ced4da' }}>
                                                      {selectedAspect && selectedAspect.value == lrnaspect.value && ageList && ageList.map((agegroup, agegroup_i) => {

                                                        return (
                                                          <div key={agegroup_i} className="d-flex flex-column">
                                                            <div className='d-flex flex-row justify-content-between align-items-center ps-4 py-2 cursor-pointer' title={agegroup.agegroup_code}
                                                              style={{ fontSize: 14, fontWeight: '600', position: 'relative' }}
                                                              onClick={() => this.onChangeAge(agegroup)}>
                                                              {/* (selectedAgegroup.value==agegroup.value) */}
                                                              <div className='p-2' style={{ flex: 1, border: (selectedAgegroup && selectedAgegroup.value == agegroup.value) ? 'solid 1px ' + agegroup.agegroup_color : 'solid 1px #ccc', borderRadius: '10px' }}>{agegroup.agegroup_code}</div>

                                                              <div style={{ borderLeft: '1px solid rgb(206, 212, 218)', height: '25px', width: '20px', borderBottomLeftRadius: '18px', position: 'absolute', left: '-1px', bottom: '25px', borderBottom: '1px solid rgb(206, 212, 218)' }}></div>
                                                            </div>
                                                          </div>
                                                        )
                                                      }
                                                      )}
                                                    </div>

                                                  </div>
                                                )
                                              }
                                              )}
                                            </div>

                                          </div>
                                        )
                                      }
                                      )}
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                          <div className='p-1' style={{ flex: 3 }}>
                            {curriculumList &&
                              <div style={{ flex: 1, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7, borderRadius: 10 }} className='p-2 cursor-pointer'>
                                {curriculumList.map((v, i) => {
                                  let newSelectedCurriculum_ids = academic_activity.curriculum_ids

                                  let findSelectedCurriculum = newSelectedCurriculum_ids.findIndex((vv, ii) => vv == v.curriculum_id)

                                  return (
                                    <div key={i} className='d-flex flex-column my-2 mx-1 px-3 py-2' style={{ backgroundColor: (findSelectedCurriculum === -1) ? brand_colors[this.props.defaultTheme.theme_id].color8 : '#badeec', borderRadius: '10px', border: (findSelectedCurriculum === -1) ? 'transparent' : 'solid 1px #62c4eb' }} onClick={() => {
                                      if (findSelectedCurriculum === -1) {
                                        newSelectedCurriculum_ids.push(v.curriculum_id)
                                      } else {
                                        newSelectedCurriculum_ids.splice(findSelectedCurriculum, 1)
                                      }
                                      this.setStateAcademicActivity('curriculum_ids', newSelectedCurriculum_ids)
                                    }}>
                                      <div className='d-flex flex-row mb-2' style={{ fontSize: 14 }}>
                                        <div className='me-2' style={{ fontWeight: '600' }}>{v.curriculum_ref_num}</div>
                                        <div className='d-flex flex-row flex-wrap'>
                                          {(parseInt(this.props.defaultLanguage.lang_id) == 1)
                                            ? v.curriculum_desc || v.curriculum_code
                                            : v.curriculum_desc2 || v.curriculum_desc || v.curriculum_code}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                                )}
                              </div>
                            }
                          </div>
                        </div>
                        : <div className='d-flex flex-row p-2' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 10 }}>
                          <div className='p-1' style={{ flex: 1 }}>
                            {selectedCurriculumList &&
                              <div style={{ flex: 1, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7, borderRadius: 10 }} className='p-2 cursor-pointer'>
                                {selectedCurriculumList.map((v, i) => {
                                  let newSelectedCurriculum_ids = academic_activity.curriculum_ids
                                  let findSelectedCurriculum = newSelectedCurriculum_ids.findIndex((vv, ii) => vv == v.curriculum_id)
                                  return (
                                    <div key={i} className='d-flex flex-column my-2 mx-1 px-3 py-2' style={{ backgroundColor: (findSelectedCurriculum === -1) ? brand_colors[this.props.defaultTheme.theme_id].color8 : '#badeec', borderRadius: '10px', border: (findSelectedCurriculum === -1) ? 'transparent' : 'solid 1px #62c4eb' }} onClick={() => {
                                      if (findSelectedCurriculum === -1) {
                                        newSelectedCurriculum_ids.push(v.curriculum_id)
                                      } else {
                                        newSelectedCurriculum_ids.splice(findSelectedCurriculum, 1)
                                      }
                                      this.setStateAcademicActivity('curriculum_ids', newSelectedCurriculum_ids)
                                    }}>
                                      <div className='d-flex flex-row mb-2' style={{ fontSize: 14 }}>
                                        <div className='me-2' style={{ fontWeight: '600' }}>{v.curriculum_ref_num}</div>
                                        <div className='d-flex flex-row flex-wrap'>
                                          {(parseInt(this.props.defaultLanguage.lang_id) == 1)
                                            ? v.curriculum_desc || v.curriculum_code
                                            : v.curriculum_desc2 || v.curriculum_desc || v.curriculum_code}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                                )}
                              </div>
                            }
                          </div>
                        </div>
                      }


                      <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} id='form_section_1.8'>
                        <span className='heading'>{'Skills'}</span>
                      </div>
                      {/* SKILLS */}
                      {this.state.academic_activity_resources.filter((v) => (v.aar_type == 'skill' && !v.editing)).length > 0 &&
                        <div className="d-flex flex-column mb-3 p-2" style={{ width: '100%' }}>
                          {this.state.academic_activity_resources.map((v, i) => {
                            return (v.aar_type == 'skill' && !v.editing) &&
                              (<div key={i} className='d-flex flex-row  align-items-center p-2 mb-1' style={{ backgroundColor: '#fbfbfb', borderRadius: 5 }}>
                                <div className='d-flex flex-row justify-content-between me-3'>
                                  <Button variant='warning' size='sm' className='me-2'>
                                    <FontAwesomeIcon
                                      icon={faPencil}
                                      onClick={() => {
                                        let academic_activity_resources = this.state.academic_activity_resources;
                                        academic_activity_resources = academic_activity_resources.map((vv, ii) => {
                                          return i == ii ? { ...vv, editing: true } : { ...vv };
                                        });
                                        this.setState({ academic_activity_resources: academic_activity_resources });
                                      }}
                                    />
                                  </Button>
                                  <Button variant='danger' size='sm' className='me-2'>
                                    <FontAwesomeIcon
                                      icon={faTrashCan}
                                      onClick={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: true, id: v.aar_id, action: () => this.deleteActivityResources() } })}
                                    />
                                  </Button>


                                </div>
                                <div className='d-flex flex-row flex-wrap' style={{ flex: 1 }}>
                                  {v.aar_title}
                                </div>
                              </div>)
                          })}
                        </div>
                      }
                      <div className="d-flex flex-column p-2" style={{ width: '100%' }}>
                        <div className='mb-3'>
                          <Form.Control
                            as='textarea'
                            placeholder={t('Enter skill here')}
                            rows={2}
                            value={editSkill ? editSkill.aar_title : ''}
                            onChange={(event) => {
                              this.setActivityResource('aar_title', event.target.value, 'skill', editSkill ? editSkill.aar_id : '');
                            }}
                          />
                        </div>
                        <div className='d-flex flex-row justify-content-end align-items-center'>
                          <Button
                            className='btn btn-primary btn-icon'
                            onClick={() => {
                              let academic_activity_resources = this.state.academic_activity_resources;
                              academic_activity_resources = academic_activity_resources.map((v, i) => {
                                if (v.editing && v.aar_type == 'skill') {
                                  return { ...v, editing: false };
                                }
                                return v;
                              });
                              this.setState({ academic_activity_resources }, () => this.checkCompletedFormSectionsActivity());
                            }}
                          >
                            {t('Add Skill')}{' '}
                            <FontAwesomeIcon icon={faPlus} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ ontSize: 16 }} />
                          </Button>
                        </div>
                      </div>


                    </div>
                  )}
                  {/* SECTION 2 */}
                  {this.state.formSectionActive.parent == '2' && (
                    <div id='form_section_2'>
                      {/* ADD ATTACHMENT */}
                      <div id='form_section_2.1'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'Attachments'}</span>
                        </div>
                        <div className='d-flex flex-column p-2'>
                          <div>
                            <div style={{ flexDirection: 'column' }} className='pic-prev d-flex justify-content-center mb-3'>
                              <div className='d-flex flex-column' style={{ height: 200, overflow: 'hidden', borderStyle: 'dashed', borderColor: '#b3b3b3', borderWidth: 1, borderRadius: 10, backgroundColor: '#f8f8f8' }}>
                                <div className='d-flex flex-row justify-content-center align-items-center' style={{ width: '100%', flex: 1, overflowY: 'auto' }}>
                                  {academic_activity_attachments.map((v, i) => {
                                    if (!v.edit) {
                                      return null
                                    }
                                    return (
                                      <div key={i} style={{ position: 'relative', borderRadius: 5, borderStyle: 'solid', borderWidth: 1, borderColor: '#ced4da', minHeight: 100, minWidth: 100, height: 100, width: 100 }} className='d-flex justify-content-center align-items-center me-1'>
                                        {v.data.type.includes('image') && (
                                          <>
                                            <img src={v.url} alt={t('Preview')} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                          </>
                                        )}
                                        {v.data.type.includes('application') && (
                                          <>
                                            <img src={pdfAttachment} alt={t('Preview')} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                          </>
                                        )}
                                        <div style={{ position: 'absolute', bottom: 0, right: 0, width: '100%' }}>
                                          <Row>
                                            <Col className='text-end'>
                                              <button
                                                onClick={() => {
                                                  academic_activity_attachments.splice(i, 1);
                                                  this.setState({ academic_activity_attachments });
                                                }}
                                                style={{ background: 'none', border: 0 }}
                                                className='m-1'
                                              >
                                                <FontAwesomeIcon icon={faTrashCan} style={{ color: brand_colors[this.props.defaultTheme.theme_id].color11 }} />
                                              </button>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    );
                                  })}
                                  <div style={{ position: 'relative', borderRadius: 5, borderStyle: 'solid', borderWidth: 1, borderColor: '#ced4da', minHeight: 100, minWidth: 100, height: 100, width: 100, padding: 5 }} className='d-flex justify-content-center align-items-center'>
                                    <button onClick={() => this.filePicker.current.click()} style={{ background: 'none', border: 0 }}>
                                      <FontAwesomeIcon icon={faCloudArrowUp} style={{ fontSize: 40, color: brand_colors[this.props.defaultTheme.theme_id].color18 }} />
                                    </button>
                                  </div>
                                </div>
                                <div className='d-flex flex-row align-items-center my-2 px-2' style={{ width: '100%' }}>
                                  <div style={{ flex: 1 }} className='me-3'>
                                    <Form.Control type='text' placeholder={t('Caption')}
                                      value={this.state.academic_activity_attachment_caption}
                                      onChange={(e) => this.setState({ academic_activity_attachment_caption: e.target.value })} />
                                  </div>
                                  <div>
                                    <Button variant='primary' onClick={() => {
                                      let new_academic_activity_attachments = [...this.state.academic_activity_attachments]
                                      new_academic_activity_attachments = new_academic_activity_attachments.map((v) => {
                                        if (v.edit) {
                                          return { ...v, edit: false, caption: this.state.academic_activity_attachment_caption }
                                        }
                                        return v
                                      })
                                      this.setState({ academic_activity_attachment_caption: '', academic_activity_attachments: new_academic_activity_attachments })
                                    }}>
                                      <FontAwesomeIcon icon={faPlus} />
                                      {' '}{t('Add Image')}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                              <Form.Control className='d-none' ref={this.filePicker} type='file' multiple onChange={this.addActivityAttachment} name='academic_activity_attachments' />
                            </div>

                          </div>
                          <div className='d-flex flex-row flex-wrap'>
                            {academic_activity_attachments.map((v, i) => {
                              if (v.edit) {
                                return null
                              }
                              return (
                                <div key={i} className='me-1 mb-1'>
                                  <div style={{ position: 'relative', borderRadius: 5, borderStyle: 'solid', borderWidth: 1, borderColor: '#ced4da', height: 150, overflow: 'hidden' }} className='d-flex justify-content-center align-items-center'>
                                    {v.data.type.includes('image') && (
                                      <>
                                        <img src={v.url} alt={t('Preview')} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                      </>
                                    )}
                                    {v.data.type.includes('application') && (
                                      <>
                                        <img src={pdfAttachment} alt={t('Preview')} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                      </>
                                    )}
                                    <div style={{ position: 'absolute', bottom: 0, right: 0, backgroundColor: 'rgba(0, 0, 0, 0.2)', width: '100%' }}>
                                      <Row>
                                        <div className='ps-3' style={{ color: brand_colors[this.props.defaultTheme.theme_id].color8, flex: 1 }}>{v.caption}</div>
                                        <div className='text-end' style={{ width: '50px' }}>
                                          <button
                                            onClick={() => {
                                              academic_activity_attachments.splice(i, 1);
                                              this.setState({ academic_activity_attachments });
                                            }}
                                            style={{ background: 'none', border: 0 }}
                                          >
                                            <FontAwesomeIcon icon={faTrashCan} style={{ fontSize: 16, color: brand_colors[this.props.defaultTheme.theme_id].color11 }} />
                                          </button>
                                        </div>
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      {/* EXTERNAL RESOURCES */}
                      <div id='form_section_2.2'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'External Resources'}</span>
                        </div>
                        {this.state.academic_activity_resources.filter((v) => (v.aar_type == 'external_resource' && !v.editing)).length > 0 &&
                          <div className="d-flex flex-column mb-3 p-2" style={{ width: '100%' }}>
                            {this.state.academic_activity_resources.map((v, i) => {
                              return (v.aar_type == 'external_resource' && !v.editing) &&
                                (<div key={i} className='d-flex flex-row  align-items-center p-2 mb-1' style={{ backgroundColor: '#fbfbfb', borderRadius: 5 }}>
                                  <div className='d-flex flex-row justify-content-between me-3'>
                                    <Button variant='warning' size='sm' className='me-2'>
                                      <FontAwesomeIcon
                                        icon={faPencil}
                                        onClick={() => {
                                          let academic_activity_resources = this.state.academic_activity_resources;
                                          academic_activity_resources = academic_activity_resources.map((vv, ii) => {
                                            return i == ii ? { ...vv, editing: true } : { ...vv };
                                          });
                                          this.setState({ academic_activity_resources: academic_activity_resources });
                                        }}
                                      />
                                    </Button>
                                    <Button variant='danger' size='sm' className='me-2'>
                                      <FontAwesomeIcon
                                        icon={faTrashCan}
                                        onClick={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: true, id: v.aar_id, action: () => this.deleteActivityResources() } })}
                                      />
                                    </Button>
                                  </div>
                                  <div className='d-flex flex-row' style={{ flex: 1 }}>
                                    <div className={(v.aar_public == 1) ? 'badge badge-light-success' : 'badge badge-light-warning'}>{(v.aar_public == 1) ? 'Public' : 'Private'}</div>
                                    <div className='d-flex flex-row flex-wrap ms-3' style={{ flex: 1 }}>
                                      <a href={v.aar_url} target='_blank'>
                                        {v.aar_title}
                                      </a>
                                    </div>
                                  </div>
                                </div>)
                            })}
                          </div>
                        }
                        <div className="d-flex flex-column p-2" style={{ width: '100%' }}>
                          <div className="d-flex flex-row align-items-center mb-3">
                            <div style={{ flex: 1 }} className='me-2'>
                              <Form.Group>
                                <Form.Label>
                                  {t('Title')}
                                </Form.Label>
                                <Form.Control
                                  value={editExternalResource ? editExternalResource.aar_title : ''}
                                  onChange={(event) => {
                                    this.setActivityResource('aar_title', event.target.value, 'external_resource', editExternalResource ? editExternalResource.aar_id : '');
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div style={{ flex: 1 }} className='me-1'>
                              <Form.Group>
                                <Form.Label>
                                  {t('URL')}
                                </Form.Label>
                                <Form.Control
                                  value={editExternalResource ? editExternalResource.aar_url : ''}
                                  onChange={(event) => {
                                    this.setActivityResource('aar_url', event.target.value, 'external_resource', editExternalResource ? editExternalResource.aar_id : '');
                                  }}
                                />
                              </Form.Group>
                            </div>
                            <div style={{ flex: 1 }} className='d-flex flex-row align-items-center justify-content-center'>
                              <Form.Group className='pt-2'>
                                <Form.Check
                                  type="switch"
                                  label={t('Share with Students')}
                                  onChange={() => this.setActivityResource('aar_public', editExternalResource ? (editExternalResource.aar_public) ? 0 : 1 : 0, 'external_resource', editExternalResource ? editExternalResource.aar_id : '')}
                                  checked={editExternalResource ? editExternalResource.aar_public : 1}
                                />
                              </Form.Group>
                            </div>
                          </div>
                          <div className='d-flex flex-row justify-content-end align-items-center'>
                            <Button
                              className='btn btn-primary btn-icon'
                              onClick={() => {
                                let academic_activity_resources = this.state.academic_activity_resources;
                                academic_activity_resources = academic_activity_resources.map((v, i) => {
                                  if (v.editing && v.aar_type == 'external_resource') {
                                    return { ...v, editing: false };
                                  }
                                  return v;
                                });
                                this.setState({ academic_activity_resources }, () => this.checkCompletedFormSectionsActivity());
                              }}
                            >
                              {t('Add External Resource')}{' '}
                              <FontAwesomeIcon icon={faPlus} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ ontSize: 16 }} />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* SECTION 3 */}
                  {this.state.formSectionActive.parent == '3' && (
                    <div id='form_section_3'>

                      {/* Transdisciplinary Theme 3.1*/}
                      <div id='form_section_3.1'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'International Baccalaureate'}</span>
                          <div style={{ fontSize: 12, color: brand_colors[this.props.defaultTheme.theme_id].color9 }}>{t('Select the transdisciplinary theme for this Activity')}</div>
                        </div>
                        <div className="p-2">
                          {!transdisciplinary_theme
                            ? <div className='d-flex flex-row py-2 px-1' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7, borderRadius: 10 }}>
                              {this.state.academicLessonAttributes.map((vvv, iii) => {
                                return (vvv.ala_type == 'lesson_focus' && vvv.ala_parent_id == 0) &&
                                  <div key={iii} className='cursor-pointer mx-1' style={{ width: '20%', height: 150 }} onClick={() => {
                                    let academic_activity_resources = this.state.academic_activity_resources
                                    // DON'T CHANGE IN CASE THE SAME BOX IS CLICKED
                                    if (transdisciplinary_theme && transdisciplinary_theme.aar_type_id != vvv.ala_id) {
                                      // REMOVE ALL CHILDREN
                                      academic_activity_resources = academic_activity_resources.filter((vvvv, iiii) => {
                                        return (vvvv.aar_type != 'transdisciplinary_theme_focus')
                                      })
                                      // THEN CHANGE THE PARENT SELECTION
                                      academic_activity_resources = academic_activity_resources.map((vvvv, iiii) => {
                                        return (vvvv.aar_type == 'transdisciplinary_theme')
                                          ? { ...vvvv, aar_title: vvv.ala_title, aar_type_id: vvv.ala_id }
                                          : { ...vvvv }
                                      })
                                    } else {
                                      // ADD NEW PARENT
                                      academic_activity_resources.push({
                                        aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
                                        aar_type: 'transdisciplinary_theme',
                                        aar_title: vvv.ala_title,
                                        aar_desc: '',
                                        aar_type_id: vvv.ala_id,
                                      })
                                    }
                                    this.setState({ academic_activity_resources }, () => {
                                      this.checkCompletedFormSectionsActivity()
                                    })
                                  }}>
                                    <div style={{ borderRadius: 10, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, width: '100%', height: '100%', border: 'solid 2px #fff' }} className='d-flex flex-column align-items-center justify-content-center div_hover_transdisciplinary'>
                                      <div className='div_image' style={{ height: '60%' }}>
                                        <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_lesson_attributes/' + vvv.ala_description_2} style={{ height: '100%' }} />
                                      </div>
                                      <div className='text-center p-2'>{vvv.ala_title}</div>
                                    </div>
                                  </div>
                              })}
                            </div>
                            : <div className='d-flex flex-column ' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7, borderRadius: 10 }}>
                              <div className='d-flex flex-row align-items-center py-2 px-1' style={{ borderBottom: 'solid 1px #e5e5e5' }}>
                                <div className='px-2'>
                                  <FontAwesomeIcon icon={faAngleLeft} className='cursor-pointer' onClick={() => {
                                    let academic_activity_resources = this.state.academic_activity_resources
                                    academic_activity_resources = academic_activity_resources.filter((vvvv, iiii) => {
                                      return (vvvv.aar_type != 'transdisciplinary_theme' && vvvv.aar_type != 'transdisciplinary_theme_focus')
                                    })
                                    this.setState({ academic_activity_resources })
                                  }} />
                                </div>
                                <div className='d-flex flex-row align-items-center'>
                                  <div className='px-2' style={{ height: 30 }}>
                                    <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_lesson_attributes/' + transdisciplinary_theme.image} style={{ height: '100%' }} />
                                  </div>
                                  <div>{transdisciplinary_theme.aar_title}</div>
                                </div>
                              </div>
                              <div className='d-flex flex-column'>
                                <div style={{ width: '100%' }} className='pt-2 px-3'>
                                  <div style={{ fontSize: 14, color: brand_colors[this.props.defaultTheme.theme_id].color9, opacity: 0.8 }}>{t('Select the focus of transdisciplinary theme.')}</div>
                                  <div style={{ fontSize: 14, color: brand_colors[this.props.defaultTheme.theme_id].color9, opacity: 0.6 }}>{t('Which parts of the Transdisciplinary Theme will the activity focus on?')}</div>
                                </div>
                                <div style={{ width: '100%' }}>
                                  <div className='d-flex flex-row flex-wrap mt-2 px-1'>
                                    {(transdisciplinary_theme) && this.state.academicLessonAttributes.map((vvv, iii) => {
                                      let academic_activity_resourcesFind = this.state.academic_activity_resources.find((vvvv, iiii) => {
                                        return (vvvv.aar_type == 'transdisciplinary_theme_focus' && vvvv.aar_type_id == vvv.ala_id)
                                      })

                                      let thisClassName = 'd-flex flex-row justify-content-center align-items-center cursor-pointer div_hover_transdisciplinary p-2 mb-1 text-center'
                                      if (academic_activity_resourcesFind) {
                                        thisClassName += ' active'
                                      }

                                      return (vvv.ala_type == 'lesson_focus' && transdisciplinary_theme.aar_type_id == vvv.ala_parent_id)
                                        ? (<div key={iii} style={{ width: '33.33%' }} className="d-flex justify-content-center align-items-center p-1">
                                          <div className={thisClassName} style={{ width: '100%', minHeight: 100, fontSize: 14, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 10 }} onClick={() => {
                                            let academic_activity_resources = this.state.academic_activity_resources
                                            let academic_activity_resourcesFind = academic_activity_resources.findIndex((vvvv, iiii) => {
                                              return (vvvv.aar_type == 'transdisciplinary_theme_focus' && vvvv.aar_type_id == vvv.ala_id)
                                            })
                                            // IF NOT IN ARRAY ALREADY THEN ADD
                                            if (academic_activity_resourcesFind == -1) {
                                              academic_activity_resources.push({
                                                aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
                                                aar_type: 'transdisciplinary_theme_focus',
                                                aar_title: vvv.ala_title,
                                                aar_desc: '',
                                                aar_type_id: vvv.ala_id,
                                              })
                                            }
                                            //JUST REMOVE FROM ARRAY IF ALREADY EXISTS
                                            else {
                                              academic_activity_resources.splice(academic_activity_resourcesFind, 1);
                                            }
                                            this.setState({ academic_activity_resources }, () => {
                                              this.checkCompletedFormSectionsActivity()
                                            })
                                          }}>
                                            <span className='title'>{vvv.ala_title}</span>
                                          </div>
                                        </div>) : null
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          }

                        </div>
                      </div>

                      {/* Approaches to learning 3.2*/}
                      <div id='form_section_3.2'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'Approaches to learning'}</span>
                          <div>
                            <Button variant='warning' size='sm' data-tooltip-id="tooltip_aar_approaches_to_learning" data-tooltip-variant='warning' data-tooltip-html={
                              `<div><div>These are the tools that students use across all subject areas to develop into successful students</div><div>Students get the opportunity to practice these skills and reflect on how they apply these skills to their everyday learning.</div></div>`
                            }>
                              <FontAwesomeIcon icon={faCircleQuestion} />
                            </Button>
                            <Tooltip id="tooltip_aar_approaches_to_learning" />
                          </div>
                        </div>
                        <div className="p-2">
                          <div className='d-flex flex-column py-1 px-2' style={{ width: '100%', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7, fontSize: 14, borderRadius: 10 }}>
                            {this.state.academicLessonAttributes.map((vvv, iii) => {
                              if (vvv.ala_type == 'approaches_to_learning' && vvv.ala_parent_id == 0) {
                                let allChildren = this.state.academicLessonAttributes.filter((vvvv, iiii) => vvvv.ala_parent_id == vvv.ala_id)
                                let selectedChildren = []
                                if (!this.state.refApproachesToLearning.ala_ids.includes(vvv.ala_id)) {
                                  allChildren.map((vvvv, iiii) => {
                                    let find = this.state.academic_activity_resources.find((vvvvv, iiiii) => ('approaches_to_learning' == vvvvv.aar_type && vvvv.ala_id == vvvvv.aar_type_id))
                                    if (find) {
                                      selectedChildren.push(vvvv)
                                    }
                                  })
                                }
                                return <div key={iii} className='my-1 p-2' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 5, width: '100%' }} >
                                  <div className='d-flex flex-row align-items-center justify-content-between cursor-pointer' style={{ width: '100%', fontSize: 16 }}>
                                    <div style={{ fontWeight: 600, flex: 1 }} onClick={() => this.state.refApproachesToLearning.toggleModal(vvv.ala_id)}>{vvv.ala_title}</div>
                                    <div className='px-2' onClick={() => this.state.refApproachesToLearning.toggleModal(vvv.ala_id)}>
                                      <FontAwesomeIcon icon={(this.state.refApproachesToLearning.ala_ids.includes(vvv.ala_id)) ? faAngleUp : faAngleDown} />
                                    </div>
                                  </div>

                                  {(allChildren.length > 0 && this.state.refApproachesToLearning.ala_ids.includes(vvv.ala_id))
                                    && <div className='mt-1 pt-1' style={{ borderTop: 'solid 1px #f0f0f0', width: '100%' }}>

                                      <div className='d-flex flex-column alert-side-primary p-2 mb-2'>
                                        <div style={{ fontWeight: 600 }} className='pb-1'>{vvv.ala_title}</div>
                                        <div className='description'>{vvv.ala_description_1}</div>
                                      </div>

                                      {allChildren.map((vvvv, iiii) => {

                                        let findSelected = this.state.academic_activity_resources.findIndex((vvvvv, iiiii) => ('approaches_to_learning' == vvvvv.aar_type && vvvv.ala_id == vvvvv.aar_type_id))

                                        return <div className='d-flex flex-row align-items-center p-2 my-2 cursor-pointer' style={{ color: brand_colors[this.props.defaultTheme.theme_id][(findSelected !== -1) ? 'color8' : 'color9'], border: 'solid 1px #b4b4b4', borderRadius: 5, fontSize: '14px', backgroundColor: (findSelected !== -1) ? '#2c70ff' : brand_colors[this.props.defaultTheme.theme_id]['color8'] }}
                                          onClick={() => {
                                            let new_academic_activity_resources = [...this.state.academic_activity_resources]
                                            if (findSelected !== -1) {
                                              new_academic_activity_resources.splice(findSelected, 1)
                                            }
                                            else {
                                              new_academic_activity_resources.push({
                                                aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
                                                aar_type: 'approaches_to_learning',
                                                aar_title: vvvv.ala_title,
                                                aar_desc: vvvv.ala_description_1,
                                                aar_type_id: vvvv.ala_id,
                                              })
                                            }
                                            this.setState({ academic_activity_resources: new_academic_activity_resources })
                                          }}>
                                          <FontAwesomeIcon icon={(findSelected !== -1) ? faCheck : faPlus} />
                                          <div className='ps-1' style={{ fontWeight: '600' }}>
                                            {vvvv.ala_title} {' : '}
                                          </div>
                                          <div>
                                            {vvvv.ala_description_1}
                                          </div>
                                        </div>
                                      })}
                                    </div>
                                  }
                                  {(selectedChildren.length > 0 && !this.state.refApproachesToLearning.ala_ids.includes(vvv.ala_id))
                                    && <div className='mt-1 pt-1' style={{ borderTop: 'solid 1px #f0f0f0', width: '100%' }}>
                                      {selectedChildren.map((vvvv, iiii) => {
                                        return <div className='d-flex flex-row align-items-center p-2 my-2 cursor-pointer' style={{ color: brand_colors[this.props.defaultTheme.theme_id]['color9'], border: 'solid 1px #fff', borderRadius: 5, fontSize: '14px', backgroundColor: '#d1edf8' }}
                                          onClick={() => {
                                            let findSelected = this.state.academic_activity_resources.findIndex((vvvvv, iiiii) => ('approaches_to_learning' == vvvvv.aar_type && vvvv.ala_id == vvvvv.aar_type_id))

                                            let new_academic_activity_resources = [...this.state.academic_activity_resources]
                                            if (findSelected !== -1) {
                                              new_academic_activity_resources.splice(findSelected, 1)
                                            }
                                            else {
                                              new_academic_activity_resources.push({
                                                aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
                                                aar_type: 'approaches_to_learning',
                                                aar_title: vvvv.ala_title,
                                                aar_desc: vvvv.ala_description_1,
                                                aar_type_id: vvvv.ala_id,
                                              })
                                            }
                                            this.setState({ academic_activity_resources: new_academic_activity_resources })
                                          }}>
                                          <FontAwesomeIcon icon={faCheck} />
                                          <div className='ps-1' style={{ fontWeight: '600' }}>
                                            {vvvv.ala_title} {' : '}
                                          </div>
                                          <div>
                                            {vvvv.ala_description_1}
                                          </div>
                                        </div>
                                      })}
                                    </div>
                                  }


                                </div>
                              }
                              return null
                            })}

                          </div>
                        </div>
                      </div>

                      {/* Learner Profile 3.3*/}
                      <div id='form_section_3.3'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'Learner Profile'}</span>
                          <div>
                            <Button variant='warning' size='sm' data-tooltip-id="tooltip_aar_learner_profile" data-tooltip-variant='warning' data-tooltip-html={
                              `<div><div>The aim of all IB programmes is to develop internationally minded people who,</div><div>recognizing their common humanity and shared guardianship of the planet, help to create a better and more peaceful world</div><div>The IB learner profile represents 10 attributes valued by IB World Schools.</div><div>We believe these attributes, and others like them, can help individuals and groups become responsible members of local, national and global communities.</div></div>`
                            }>
                              <FontAwesomeIcon icon={faCircleQuestion} />
                            </Button>
                            <Tooltip id="tooltip_aar_learner_profile" />
                          </div>
                        </div>
                        <div className="p-2">
                          <div className='d-flex flex-row flex-wrap p-1' style={{ width: '100%', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color7, fontSize: 14, borderRadius: 10 }}>
                            {this.state.academicLessonAttributes.map((vvv, iii) => {
                              let findIndexSelectedData = this.state.academic_activity_resources.findIndex((vvvv) => (vvvv.aar_type_id == vvv.ala_id && vvvv.aar_type == 'learner_profile'))
                              if (vvv.ala_type == 'learner_profile' && vvv.ala_parent_id == 0) {

                                let thisClassName = 'cursor-pointer div_hover_transdisciplinary p-2'
                                if (findIndexSelectedData !== -1) {
                                  thisClassName += ' active'
                                }

                                return <div key={iii} style={{ width: '50%' }} className='p-1'>
                                  <div className={thisClassName} style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, minHeight: 110, borderRadius: 10, border: 'solid 2px #fff' }}
                                    onClick={() => {
                                      let academic_activity_resources = this.state.academic_activity_resources
                                      if (findIndexSelectedData !== -1) {
                                        academic_activity_resources.splice(findIndexSelectedData, 1)
                                      } else {
                                        academic_activity_resources.push({
                                          aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
                                          aar_type: 'learner_profile',
                                          aar_type_id: vvv.ala_id,
                                          aar_title: vvv.ala_title,
                                          aar_desc: vvv.ala_description_1,
                                        })
                                      }
                                      this.setState({ academic_activity_resources: academic_activity_resources }, () => this.checkCompletedFormSectionsActivity())
                                    }}>
                                    <div style={{ fontWeight: 600 }}>{vvv.ala_title}</div>
                                    <div>{vvv.ala_description_1}</div>
                                  </div>
                                </div>
                              }
                            })}
                          </div>
                        </div>
                      </div>

                      {/* Key Concepts 3.4*/}
                      <div id='form_section_3.4'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'Key Concepts'}</span>
                          <div>
                            <Button variant='info' size='sm' className='me-1' onClick={() => this.state.refKeyConcepts.toggleModal()}>
                              {t('Show All Questions')}{' '}
                              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                            </Button>
                            <Button variant='warning' size='sm' data-tooltip-id="tooltip_aar_lesson_key_concept" data-tooltip-variant='warning' data-tooltip-html={
                              `<div><div>It help students to engage in abstract thinking and conceptual thinking to cope-with tricky ideas.</div><div>Key Concepts can help learners to deal with knowledge in transdisciplinary themes, which the IB intends to encourage.</div><div>This kind of learning is not limited to factual concepts and content,</div><div>helping students to engage with broader concepts that can motivate inquisitive, creative and critical thinking.</div></div>`
                            }>
                              <FontAwesomeIcon icon={faCircleQuestion} />
                            </Button>
                            <Tooltip id="tooltip_aar_lesson_key_concept" />
                          </div>
                        </div>
                        <div className="p-2">
                          <div style={{ overflowY: 'auto' }} ref={this.refLessonKeyConcept}  >
                            <div className='d-flex flex-row' style={{ width: this.state.academicLessonAttributes.filter((vvv) => (vvv.ala_type == 'lesson_key_concept' && vvv.ala_parent_id == 0)).length * this.state.refLessonKeyConcept.width + 'px' }}>
                              {this.state.academicLessonAttributes.map((vvv, iii) => {
                                let findIndexSelectedData = this.state.academic_activity_resources.findIndex((vvvv) => (vvvv.aar_type_id == vvv.ala_id && vvvv.aar_type == 'lesson_key_concept'))
                                if (vvv.ala_type == 'lesson_key_concept' && vvv.ala_parent_id == 0) {
                                  return <div style={{ minWidth: this.state.refLessonKeyConcept.width + 'px' }} className='px-3 py-2'>
                                    <div className='d-flex flex-column alert-side-primary p-2'>
                                      <div style={{ fontWeight: 600 }} className='pb-1'>{vvv.ala_title}</div>
                                      <div className='description'>{vvv.ala_description_2}</div>
                                    </div>

                                    <Form.Group style={{ width: '100%' }} className='mt-1'>
                                      <Form.Label>
                                        {vvv.ala_description_1}
                                      </Form.Label>
                                      <Form.Control as='textarea' rows={3} value={(findIndexSelectedData !== -1) ? this.state.academic_activity_resources[findIndexSelectedData].aar_desc : ''} onChange={(event) => {
                                        let academic_activity_resources = this.state.academic_activity_resources

                                        if (findIndexSelectedData != -1) {
                                          if (event.target.value == '') {
                                            academic_activity_resources.splice(findIndexSelectedData, 1)
                                          } else {
                                            academic_activity_resources[findIndexSelectedData]['aar_desc'] = event.target.value
                                          }
                                        } else {
                                          academic_activity_resources.push({
                                            aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
                                            aar_type: 'lesson_key_concept',
                                            aar_type_id: vvv.ala_id,
                                            aar_title: vvv.ala_title,
                                            aar_desc: event.target.value,
                                          })
                                        }
                                        this.setState({ academic_activity_resources })
                                      }}
                                        onBlur={() => this.checkCompletedFormSectionsActivity()}
                                      />
                                    </Form.Group>
                                  </div>
                                }
                              })}
                            </div>
                          </div>
                          <div className="d-flex flex-row justify-content-between align-items-center px-2">
                            <Button variant={(this.state.refLessonKeyConcept.active == 0) ? 'light' : 'danger'} onClick={() => {
                              let refLessonKeyConcept = this.state.refLessonKeyConcept
                              if (refLessonKeyConcept.active > 0) {
                                refLessonKeyConcept.active = refLessonKeyConcept.active - 1
                                this.setState({ refLessonKeyConcept })
                                this.refLessonKeyConcept.current.scrollTo((refLessonKeyConcept.active) * this.state.refLessonKeyConcept.width, 0)
                              }
                            }}>
                              {t('Previous Question')}
                            </Button>
                            <div className='d-flex flex-row align-items-center justify-content-center px-1' style={{ flex: 1 }}>
                              {this.state.academicLessonAttributes.filter((vvv) => (vvv.ala_type == 'lesson_key_concept' && vvv.ala_parent_id == 0)).map((vvv, iii) => {
                                return <div style={{ minWidth: 7, minHeight: 7, borderRadius: 14, backgroundColor: (this.state.refLessonKeyConcept.active == iii) ? '#e8458a' : '#d9d9d9' }} className="mx-1" onClick={() => {
                                  this.setState({ refLessonKeyConcept: { ...this.state.refLessonKeyConcept, active: iii } })
                                  this.refLessonKeyConcept.current.scrollTo(iii * this.state.refLessonKeyConcept.width, 0)
                                }}></div>
                              })}
                            </div>
                            <Button variant={(this.state.refLessonKeyConcept.active == (this.state.academicLessonAttributes.filter((vvv) => (vvv.ala_type == 'lesson_key_concept' && vvv.ala_parent_id == 0)).length - 1)) ? 'light' : 'warning'} onClick={() => {
                              let refLessonKeyConcept = this.state.refLessonKeyConcept
                              if (refLessonKeyConcept.active < (this.state.academicLessonAttributes.filter((vvv) => (vvv.ala_type == 'lesson_key_concept' && vvv.ala_parent_id == 0)).length - 1)) {
                                refLessonKeyConcept.active = refLessonKeyConcept.active + 1
                                this.setState({ refLessonKeyConcept })
                                this.refLessonKeyConcept.current.scrollTo(refLessonKeyConcept.active * this.state.refLessonKeyConcept.width, 0)
                              }
                            }}>
                              {t('Next Question')}
                            </Button>
                          </div>
                        </div>
                      </div>
                      {/* Goals & Success Criteria 3.5*/}
                      <div id='form_section_3.5'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'Goals & Success Criteria'}</span>
                          <div>
                            <Button variant='warning' size='sm' data-tooltip-id="tooltip_aar_success" data-tooltip-variant='warning' data-tooltip-html={
                              `<div>What is it we want students to know, understand and be able to do</div><div>How are learning goals and success criteria co-constructed between teachers and students?</div>`
                            }>
                              <FontAwesomeIcon icon={faCircleQuestion} />
                            </Button>
                            <Tooltip id="tooltip_aar_success" />
                          </div>
                        </div>
                        {this.state.academic_activity_resources.filter((v) => (v.aar_type == 'success' && !v.editing)).length > 0 &&
                          <div className="d-flex flex-column mb-3 p-2" style={{ width: '100%' }}>
                            {this.state.academic_activity_resources.map((v, i) => {
                              return (v.aar_type == 'success' && !v.editing) &&
                                (<div key={i} className='d-flex flex-row  align-items-center p-2 mb-1' style={{ backgroundColor: '#fbfbfb', borderRadius: 5 }}>
                                  <div className='d-flex flex-row justify-content-between me-3'>
                                    <Button variant='warning' size='sm' className='me-2'>
                                      <FontAwesomeIcon
                                        icon={faPencil}
                                        onClick={() => {
                                          let academic_activity_resources = this.state.academic_activity_resources;
                                          academic_activity_resources = academic_activity_resources.map((vv, ii) => {
                                            return i == ii ? { ...vv, editing: true } : { ...vv };
                                          });
                                          this.setState({ academic_activity_resources: academic_activity_resources });
                                        }}
                                      />
                                    </Button>
                                    <Button variant='danger' size='sm' className='me-2'>
                                      <FontAwesomeIcon
                                        icon={faTrashCan}
                                        onClick={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: true, id: v.aar_id, action: () => this.deleteActivityResources() } })}
                                      />
                                    </Button>
                                  </div>
                                  <div className='d-flex flex-row ps-2' style={{ flex: 1 }}>
                                    {v.aar_title}
                                  </div>
                                </div>)
                            })}
                          </div>
                        }
                        <div className="d-flex flex-column p-2" style={{ width: '100%' }}>
                          <div className="d-flex flex-row align-items-center mb-3">
                            <div style={{ flex: 1 }}>
                              <Form.Group>
                                <Form.Label>
                                  {t('Goal')}
                                </Form.Label>
                                <Form.Control
                                  as='textarea'
                                  rows={2}
                                  value={editSuccess ? editSuccess.aar_title : ''}
                                  onChange={(event) => {
                                    this.setActivityResource('aar_title', event.target.value, 'success', editSuccess ? editSuccess.aar_id : '');
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                          <div className='d-flex flex-row justify-content-end align-items-center'>
                            <Button
                              className='btn btn-primary btn-icon'
                              onClick={() => {
                                let academic_activity_resources = this.state.academic_activity_resources;
                                academic_activity_resources = academic_activity_resources.map((v, i) => {
                                  if (v.editing && v.aar_type == 'success') {
                                    return { ...v, editing: false };
                                  }
                                  return v;
                                });
                                this.setState({ academic_activity_resources }, () => this.checkCompletedFormSectionsActivity());
                              }}
                            >
                              {t('Add')}{' '}
                              <FontAwesomeIcon icon={faPlus} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ ontSize: 16 }} />
                            </Button>
                          </div>
                        </div>
                      </div>

                      {/* Lines of Enquiry 3.6*/}
                      <div id='form_section_3.6'>
                        <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} >
                          <span className='heading'>{'Lines of Enquiry'}</span>
                          <div>
                            <Button variant='warning' size='sm' data-tooltip-id="tooltip_aar_lines_of_enquiry" data-tooltip-variant='warning' data-tooltip-html={
                              `<div>What lines of inquiry will define the scope of inquiry into the central idea?</div>`
                            }>
                              <FontAwesomeIcon icon={faCircleQuestion} />
                            </Button>
                            <Tooltip id="tooltip_aar_lines_of_enquiry" />
                          </div>
                        </div>
                        {this.state.academic_activity_resources.filter((v) => (v.aar_type == 'lines_of_enquiry' && !v.editing)).length > 0 &&
                          <div className="d-flex flex-column mb-3 p-2" style={{ width: '100%' }}>
                            {this.state.academic_activity_resources.map((v, i) => {
                              return (v.aar_type == 'lines_of_enquiry' && !v.editing) &&
                                (<div key={i} className='d-flex flex-row  align-items-center p-2 mb-1' style={{ backgroundColor: '#fbfbfb', borderRadius: 5 }}>
                                  <div className='d-flex flex-row justify-content-between me-3'>
                                    <Button variant='warning' size='sm' className='me-2'>
                                      <FontAwesomeIcon
                                        icon={faPencil}
                                        onClick={() => {
                                          let academic_activity_resources = this.state.academic_activity_resources;
                                          academic_activity_resources = academic_activity_resources.map((vv, ii) => {
                                            return i == ii ? { ...vv, editing: true } : { ...vv };
                                          });
                                          this.setState({ academic_activity_resources: academic_activity_resources });
                                        }}
                                      />
                                    </Button>
                                    <Button variant='danger' size='sm' className='me-2'>
                                      <FontAwesomeIcon
                                        icon={faTrashCan}
                                        onClick={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: true, id: v.aar_id, action: () => this.deleteActivityResources() } })}
                                      />
                                    </Button>
                                  </div>
                                  <div className='d-flex flex-row ps-2' style={{ flex: 1 }}>
                                    {v.aar_title}
                                  </div>
                                </div>)
                            })}
                          </div>
                        }
                        <div className="d-flex flex-column p-2" style={{ width: '100%' }}>
                          <div className="d-flex flex-row align-items-center mb-3">
                            <div style={{ flex: 1 }}>
                              <Form.Group>
                                <Form.Label>
                                  {t('Enquiry')}
                                </Form.Label>
                                <Form.Control
                                  as='textarea'
                                  rows={2}
                                  value={editLinesOfEnquiry ? editLinesOfEnquiry.aar_title : ''}
                                  onChange={(event) => {
                                    this.setActivityResource('aar_title', event.target.value, 'lines_of_enquiry', editLinesOfEnquiry ? editLinesOfEnquiry.aar_id : '');
                                  }}
                                />
                              </Form.Group>
                            </div>
                          </div>
                          <div className='d-flex flex-row justify-content-end align-items-center'>
                            <Button
                              className='btn btn-primary btn-icon'
                              onClick={() => {
                                let academic_activity_resources = this.state.academic_activity_resources;
                                academic_activity_resources = academic_activity_resources.map((v, i) => {
                                  if (v.editing && v.aar_type == 'lines_of_enquiry') {
                                    return { ...v, editing: false };
                                  }
                                  return v;
                                });
                                this.setState({ academic_activity_resources }, () => this.checkCompletedFormSectionsActivity());
                              }}
                            >
                              {t('Add')}{' '}
                              <FontAwesomeIcon icon={faPlus} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ ontSize: 16 }} />
                            </Button>
                          </div>
                        </div>
                      </div>

                    </div>
                  )}
                  {this.state.formSectionActive.parent == '4' && (
                    <div id='form_section_4'>
                      {/* ASSESSMENT */}
                      <div className={'d-flex flex-row align-items-center justify-content-between section-heading p-2 mt-2 position-sticky'} style={{ top: 0, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, zIndex: 8 }} id='form_section_4.1'>
                        <span className='heading'>{'Assessment'}</span>
                        <div>
                          <Button variant='primary'
                            onClick={() =>
                              questionModal.toggleModal({
                                aa_q_id: null,
                                aa_id: '',
                                aa_q_desc: '',
                                aa_q_order: '',
                                aa_q_file: '',
                                aa_q_type: '',
                                curriculum_ids: JSON.stringify([]),
                                aa_q_audio: '',
                                academic_activity_question_options: [],
                              })
                            }
                          >
                            <FontAwesomeIcon icon={faPlus} />
                            {' '}
                            {t('Add Question')}
                          </Button>
                        </div>
                      </div>

                      <div className='d-flex flex-column'>
                        {academic_activity_questions.map((item, index) => (
                          <div key={index} className='d-flex flex-column p-2' style={{ width: '100%' }}>
                            <div className='d-flex flex-column p-2' style={{ width: '100%', backgroundColor: '#fff', border: 'solid 1px #e8e8e8', borderRadius: 5 }}>
                              <div className='d-flex flex-row justify-content-between align-content-center mb-2' sytle={{ width: '100%' }}>
                                <div>
                                  <Button title={t('Edit')} variant='warning' size="sm" className='me-1' onClick={() => this.editQuestion(index)}>
                                    <FontAwesomeIcon icon={faEdit} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ fontSize: 13 }} />
                                  </Button>
                                  <Button
                                    variant='danger' size="sm"
                                    title={t('Delete')}
                                    onClick={() =>
                                      this.setState({
                                        deleteModal: {
                                          ...this.state.deleteModal,
                                          show: true,
                                          id: 0,
                                          action: () => {
                                            academic_activity_questions.splice(index, 1);
                                            this.setState({ academic_activity_questions, deleteModal: { ...this.state.deleteModal, show: false } }, () => this.checkCompletedFormSectionsActivity());
                                          },
                                        },
                                      })
                                    }
                                  >
                                    <FontAwesomeIcon icon={faTimes} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ fontSize: 13 }} />
                                  </Button>
                                </div>
                                <div>
                                  <Badge style={{ marginLeft: '1rem' }} bg='primary'>
                                    {aa_q_type.find((v, i) => v.value == item.aa_q_type).label}
                                  </Badge>
                                </div>
                              </div>
                              <div>
                                <div
                                  dangerouslySetInnerHTML={{ __html: item.aa_q_desc }}
                                />
                                {/* {trimThisDown(item.aa_q_desc.replace(/(<([^>]+)>)/gi, ' '), 40)} */}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                </Col>
              </div>
              <AIGenerationButton
                disabled={!academic_activity.aa_name || !academic_activity.agegroup_id || !academic_activity.aa_desc_cidea}
                style={{
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  position: 'absolute',
                  paddingTop: 5,
                  paddingBottom: 5,
                  bottom: 0,
                  right: 0,
                }}
                dynamicAIPrompt={dynamicAIPrompt} />
            </Offcanvas.Body >
          }
        </Offcanvas >

        <Modal size='xl' show={this.state.refKeyConcepts.show} onHide={this.state.refKeyConcepts.toggleModal} backdrop="static"
          keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Key Concepts')}</Modal.Title>
          </Modal.Header>
          {this.state.refKeyConcepts.show &&
            <Modal.Body>
              <div className="d-flex flex-row flex-wrap">
                {this.state.academicLessonAttributes.map((vvv, iii) => {
                  let findIndexSelectedData = this.state.academic_activity_resources.findIndex((vvvv) => (vvvv.aar_type_id == vvv.ala_id && vvvv.aar_type == 'lesson_key_concept'))
                  if (vvv.ala_type == 'lesson_key_concept' && vvv.ala_parent_id == 0) {
                    return <div style={{ width: '50%' }} className='px-3 py-2'>
                      <div className='d-flex flex-column alert-side-primary p-2'>
                        <div style={{ fontWeight: 600 }} className='pb-1'>{vvv.ala_title}</div>
                        <div className='description'>{vvv.ala_description_2}</div>
                      </div>

                      <Form.Group style={{ width: '100%' }} className='mt-1'>
                        <Form.Label>
                          {vvv.ala_description_1}
                        </Form.Label>
                        <Form.Control as='textarea' rows={3} value={(findIndexSelectedData !== -1) ? this.state.academic_activity_resources[findIndexSelectedData].aar_desc : ''} onChange={(event) => {
                          let academic_activity_resources = this.state.academic_activity_resources

                          if (findIndexSelectedData != -1) {
                            if (event.target.value == '') {
                              academic_activity_resources.splice(findIndexSelectedData, 1)
                            } else {
                              academic_activity_resources[findIndexSelectedData]['aar_desc'] = event.target.value
                            }
                          } else {
                            academic_activity_resources.push({
                              aar_id: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
                              aar_type: 'lesson_key_concept',
                              aar_type_id: vvv.ala_id,
                              aar_title: vvv.ala_title,
                              aar_desc: event.target.value,
                            })
                          }
                          this.setState({ academic_activity_resources })
                        }}
                          onBlur={() => this.checkCompletedFormSections()}
                        />
                      </Form.Group>
                    </div>
                  }
                })}
              </div>
            </Modal.Body>
          }
          <Modal.Footer>
            <Button variant='primary' onClick={this.state.refKeyConcepts.toggleModal}>
              {t('Close')}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal size='xl' show={questionModal.show} onHide={questionModal.closeModal} backdrop="static"
          keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>{questionModal.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className='custom-styled-form'>
              <Col md={6}>
                <Row style={{ position: 'relative', zIndex: 8 }}>
                  <Col md={12}>
                    <Form.Group className='mb-3' id='div_aa_q_type'>
                      <Form.Label>{t('Type')}</Form.Label>
                      <Select options={aa_q_type} onChange={(event) => this.setStateAcademicActivityQuestion('aa_q_type', event.value)} value={academic_activity_question.aa_q_type ? { value: academic_activity_question.aa_q_type, label: aa_q_type.find((v) => v.value == academic_activity_question.aa_q_type).label } : ''} />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className='mb-2'>
                    <CKEditor style={{ height: 200 }} editor={Editor} data={academic_activity_question.aa_q_desc} onChange={(event, editor) => this.setStateAcademicActivityQuestion('aa_q_desc', editor.getData())} />
                  </Col>
                </Row>
                <Row>
                  {/* <Col md={12}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Objective')}</Form.Label>
        
                              <Badge
                                style={{
                                  position: 'relative',
                                  right: '-20px',
                                  top: '9px',
                                  zIndex: 1,
                                }}
                                className='cursor-pointer'
                                bg='primary'
                                onClick={() => this.setState({ filterCurriculum: 'ALL' })}
                              >
                                {t('All')}
                                {this.state.filterCurriculum == 'ALL' && (
                                  <span style={{ borderRadius: 100, backgroundColor: brand_colors[defaultTheme.theme_id].color8, padding: 3, position: 'absolute', top: -10, right: -12 }}>
                                    <FontAwesomeIcon icon={faCircleCheck} color={brand_colors[defaultTheme.theme_id].color4} style={{ fontSize: 14 }} />
                                  </span>
                                )}
                              </Badge>
        
                              <Badge
                                className='cursor-pointer'
                                style={{
                                  marginLeft: '1rem',
                                  position: 'relative',
                                  right: '-20px',
                                  top: '9px',
                                  zIndex: 1,
                                }}
                                bg='warning'
                                onClick={() => this.setState({ filterCurriculum: 'LINKED' })}
                              >
                                {t('Activity Linked')}
                                {this.state.filterCurriculum == 'LINKED' && (
                                  <span style={{ borderRadius: 100, backgroundColor: brand_colors[defaultTheme.theme_id].color8, padding: 3, position: 'absolute', top: -10, right: -12 }}>
                                    <FontAwesomeIcon icon={faCircleCheck} color={brand_colors[defaultTheme.theme_id].color4} style={{ fontSize: 14 }} />
                                  </span>
                                )}
                              </Badge>
        
                              <Select
                                isMulti={true}
                                closeMenuOnSelect={false}
                                options={
                                  this.state.filterCurriculum == 'ALL'
                                    ? curriculums.curriculum_options_grouped
                                    : JSON.parse(academic_activity.curriculum_ids).map((v, i) => {
                                      return { value: v, label: curriculums.curriculum_options.find((vv) => vv.value == v).label };
                                    })
                                }
                                onChange={(event) => {
                                  this.setStateAcademicActivityQuestion('curriculum_ids', JSON.stringify(event.map((v) => v.value)));
                                }}
                                value={JSON.parse(academic_activity_question.curriculum_ids).map((v, i) => {
                                  return { value: v, label: curriculums.curriculum_options.find((vv) => vv.value == v).label };
                                })}
                              />
                            </Form.Group>
                          </Col> */}
                </Row>
              </Col>
              <Col md={6}>
                <div className='d-flex justify-content-between align-items-center mb-4'>
                  <h6 className='mb-0'>{t('Question Options')}</h6>
                  <Button disabled={['BD', 'DD', 'File', 'Audio'].includes(academic_activity_question.aa_q_type) ? true : false} variant='success' onClick={this.addQuestionOption}>
                    {t('Add Option')}
                  </Button>
                </div>
                {academic_activity_question.academic_activity_question_options.map((item, index) => (
                  <Card className='mb-3 quest-opt-card' key={index}>
                    {(academic_activity_question.aa_q_type == 'MCQ' || academic_activity_question.aa_q_type == 'TF') && (
                      <button className='mark-correct' style={{ backgroundColor: item.aa_q_op_checked == 0 ? brand_colors[this.props.defaultTheme.theme_id].color10 : brand_colors[this.props.defaultTheme.theme_id].color4 }} onClick={() => this.handleOptionCheckChange(index, 'aa_q_op_checked', true)}>
                        <FontAwesomeIcon
                          icon={item.aa_q_op_checked == 0 ? faCircle : faCircleCheck}
                          color={brand_colors[this.props.defaultTheme.theme_id].color8}
                          style={{
                            fontSize: 17,
                          }}
                        />
                        <span className='ms-1'>{t('Mark as correct')}</span>
                      </button>
                    )}
                    {academic_activity_question.aa_q_type == 'MRQ' && (
                      <button
                        className='mark-correct'
                        style={{
                          paddingLeft: 8,
                          backgroundColor: item.aa_q_op_checked == 0 ? brand_colors[this.props.defaultTheme.theme_id].color10 : brand_colors[this.props.defaultTheme.theme_id].color4,
                        }}
                        onClick={() => this.handleOptionCheckChange(index, 'aa_q_op_checked')}
                      >
                        <FontAwesomeIcon icon={item.aa_q_op_checked == 0 ? faSquare : faSquareCheck} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ fontSize: 17 }} />
                        <span className='ms-1'>{t('Mark as correct')}</span>
                      </button>
                    )}
                    <button onClick={() => this.deleteOption(index)} className='btn-icon-danger'>
                      <FontAwesomeIcon icon={faTimes} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ fontSize: 16 }} />
                    </button>
                    <Card.Body>
                      {academic_activity_question.aa_q_type == 'Blanks' ? (
                        <TagsInput value={item.aa_q_op_value} onChange={this.handleOptionTagsChange(index, 'aa_q_op_value')} name='aa_q_op_value' />
                      ) : (
                        <Row>
                          <Col md={academic_activity_question.aa_q_type == 'Match' ? 6 : 12}>
                            {item.aa_q_op_text_picture &&
                              <a target='_blank' href={regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_activity_question_options/' + item.aa_q_op_text_picture}>{t('Old Attachment')}</a>
                            }

                            {<Form.Control type='file' className='mb-2' name='aa_q_op_text_picture' onChange={this.handleOptionFileChange(index)} />}

                            <Form.Control type='text' name='aa_q_op_text' value={item.aa_q_op_text} onBlur={this.handleOptionTextChange(index)} />
                          </Col>
                          {academic_activity_question.aa_q_type == 'Match' && (
                            <Col md={6} className='ps-0'>
                              {item.aa_q_op_value_picture &&
                                <a target='_blank' href={regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_activity_question_options/' + item.aa_q_op_value_picture}>{t('Old Attachment')}</a>
                              }
                              <Form.Control type='file' className='mb-2' name='aa_q_op_value_picture' onChange={this.handleOptionFileChange(index)} />
                              <Form.Control type='text' name='aa_q_op_value' value={item.aa_q_op_value} onBlur={this.handleOptionTextChange(index)} />
                            </Col>
                          )}
                        </Row>
                      )}
                    </Card.Body>
                  </Card>
                ))}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={questionModal.closeModal}>
              {t('Cancel')}
            </Button>
            <Button variant='primary' onClick={this.addUpdateQuestion}>
              {t('Save Question')}
            </Button>
          </Modal.Footer>
        </Modal>

        <SweetAlert show={this.state.deleteModal.show} warning showCancel confirmBtnText={t('Yes, delete it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.deleteModal.action} onCancel={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: false, id: 0, action: () => { } } })} focusCancelBtn>
          {t('Confirm Delete!')}
        </SweetAlert>

        <AIGenerationModal
          type='activity'
          setAIResources={this.setAIResources}
        />

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedClass: state.selectedClass.data,
  selectedSubject: state.selectedClass.subject,
  languages: state.language.languages,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
  AIContent: state.AIGenerationModal.AIContent,
});

const mapDispatchToProps = () => ({
  unsetAuthentication,
  setSelectedClass,
  setDefaultLanguage,
});

export default connect(mapStateToProps, mapDispatchToProps())(Dashboard);
